"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderSummaryItemTicketFragmentDoc = exports.OrderSummaryItemFragmentDoc = exports.OrderSummaryItemBookingFragmentDoc = exports.OrderSummaryFragmentDoc = exports.OrderMetaFragmentDoc = exports.OrderItemFragmentDoc = exports.OrderDetailsFragmentDoc = exports.OrderDetailsDocument = exports.OrderCustomerInfoFragmentDoc = exports.OrderBookingFragmentDoc = exports.MyOrderFragmentDoc = exports.MyFavoritesFragmentDoc = exports.MyDocument = exports.MyCustomerFragmentDoc = exports.MeDocument = exports.LocationFragmentDoc = exports.ListImageFragmentDoc = exports.LeaveUnauthenticatedReviewDocument = exports.LeaveUnauthenticatedActivityReviewDocument = exports.LeaveReviewDocument = exports.LeaveActivityReviewsFragmentDoc = exports.LeaveActivityReviewDocument = exports.ImagesFragmentDoc = exports.ImageTransformFormatEnum = exports.ImageTransformConfigEnum = exports.GetCartFragmentDoc = exports.GetCartDocument = exports.FavoriteButtonDocument = exports.ExtrasFragmentDoc = exports.DeskModeDocument = exports.CustomerDetailsFragmentDoc = exports.CompanySearchDocument = exports.CompanyOperatingHoursFragmentDoc = exports.CompanyHitFragmentDoc = exports.CompanyFiltersDocument = exports.CompanyDetailDocument = exports.CheckoutRedirectRentalUnitDocument = exports.CheckoutPaymentsBookingFragmentDoc = exports.CheckoutPaymentTicketFragmentDoc = exports.CheckoutPaymentOrderItemFragmentDoc = exports.CheckoutPaymentOrderFragmentDoc = exports.CheckoutPaymentOrderDocument = exports.CheckoutPaymentFragmentDoc = exports.CheckoutPaymentDocument = exports.CheckoutPaymentBookingFragmentDoc = exports.CheckoutPageDocument = exports.CheckoutOrderPageDocument = exports.CheckoutExtrasTicketFragmentDoc = exports.CheckoutExtrasOrderItemFragmentDoc = exports.CheckoutExtrasFragmentDoc = exports.CheckoutExtrasDocument = exports.CheckoutExtrasBookingRentalUnitFragmentDoc = exports.CheckoutExtrasBookingFragmentDoc = exports.CheckoutDetailsMeDocument = exports.CheckoutDetailsFragmentDoc = exports.CheckoutDetailsDocument = exports.CheckoutDetailsCustomerInfoFragmentDoc = exports.CheckoutConfirmTicketFragmentDoc = exports.CheckoutConfirmOrderItemFragmentDoc = exports.CheckoutConfirmOrderDocument = exports.CheckoutConfirmDocument = exports.CheckoutConfirmBookingFragmentDoc = exports.CheckoutCartDocument = exports.CartUpsellFragmentDoc = exports.CartTicketFragmentDoc = exports.CartStatusEnum = exports.CartStatusDocument = exports.CartOrderItemFragmentDoc = exports.CartBookingFragmentDoc = exports.CancelBookingDocument = exports.BookingStatus = exports.BookingFragmentDoc = exports.BookingCancellationPreviewDocument = exports.BookingAlterationPreviewDocument = exports.AlternativesInAccommodationDocument = exports.AlterBookingDocument = exports.AgendaFiltersDocument = exports.AddressFragmentDoc = exports.AddFavoriteRentalUnitDocument = exports.AddFavoriteCompanyDocument = exports.AddFavoriteActivityDocument = exports.ActivitySearchOrderEnum = exports.ActivitySearchDocument = exports.ActivityReviewsFragmentDoc = exports.ActivityReviewStatsFragmentDoc = exports.ActivityReviewFragmentDoc = exports.ActivityReviewDocument = exports.ActivityPlannerTimeslotFragmentDoc = exports.ActivityPlannerDocument = exports.ActivityPlannerActivityFragmentDoc = exports.ActivityIframePlannerDocument = exports.ActivityHitFragmentDoc = exports.ActivityDetailDocument = exports.ActivityCheckoutModalTimeslotFragmentDoc = exports.ActivityBookingTypesEnum = exports.ActivityAtlternativesDocument = exports.AccommodationTypeEnum = exports.AccommodationPhotosFragmentDoc = exports.AccommodationImageCategoryEnum = exports.AccommodationDetailsDocument = void 0;
exports.UpsellPurchaseStatus = exports.UpdateCustomerDocument = exports.UpdateCartFromDetailsDocument = exports.UpdateCartDocument = exports.UnitSearchPriceFilterDocument = exports.UnitSearchOrderEnum = exports.UnitSearchAlternativeDatesDocument = exports.UnitReviewsFragmentDoc = exports.UnitRelevantAlternativesFragmentDoc = exports.UnitRelevantAlternativesDocument = exports.UnitPhotosFragmentDoc = exports.UnitOwnerFragmentDoc = exports.UnitFilterPropertyCategoryFragmentDoc = exports.UnitFilterPropertiesDocument = exports.UnitFeaturesFragmentDoc = exports.UnitDetailsSearchDocument = exports.UnitDetailsDocument = exports.UnitDetailInitialTripsDocument = exports.UnitAccommodationFragmentDoc = exports.TripTypeEnum = exports.TripTypeCountFragmentDoc = exports.TripPlannerDocument = exports.TravelGroupType = exports.TransformFragmentDoc = exports.TorSitemapDocument = exports.TimeOpenClosedFragmentDoc = exports.TicketStatus = exports.TargetAudienceEnum = exports.SurchargeFragmentDoc = exports.SurchargeCalculationEnum = exports.SpecialDocument = exports.SpecialCountFragmentDoc = exports.SetCartExtrasDocument = exports.SetCartDocument = exports.SendAuthenticationEmailDocument = exports.SearchTripsDocument = exports.SearchSurchargesDocument = exports.SearchRentalUnitsOrderEnum = exports.SearchRentalUnitsFragmentDoc = exports.SearchRentalUnitsDocument = exports.SearchPageRentalUnitsDocument = exports.SearchHitTripFragmentDoc = exports.SearchHitRentalUnitFragmentDoc = exports.SearchHitFragmentDoc = exports.ReviewsDocument = exports.ReviewStatsFragmentDoc = exports.ReviewModalFragmentDoc = exports.ReviewFragmentDoc = exports.RentalUnitTypeEnum = exports.RentalUnitReviewFragmentDoc = exports.RentalUnitReviewDocument = exports.RemoveFavoriteDocument = exports.RegisterDocument = exports.PropertyFilterCountsFragmentDoc = exports.PriceLineFragmentDoc = exports.PriceLineCategoryEnum = exports.PlannerTripFragmentDoc = exports.PlannerPageRentalUnitDocument = exports.PlannerPageRentalUnitByIdDocument = exports.PaymentStatusEnum = exports.PaymentMethodEnum = exports.PaymentFragmentDoc = exports.PayOrderDocument = exports.OrderTicketFragmentDoc = exports.OrderSummaryItemUpsellPurchaseFragmentDoc = void 0;
exports.useAccommodationDetailsLazyQuery = useAccommodationDetailsLazyQuery;
exports.useAccommodationDetailsQuery = useAccommodationDetailsQuery;
exports.useActivityAtlternativesLazyQuery = useActivityAtlternativesLazyQuery;
exports.useActivityAtlternativesQuery = useActivityAtlternativesQuery;
exports.useActivityDetailLazyQuery = useActivityDetailLazyQuery;
exports.useActivityDetailQuery = useActivityDetailQuery;
exports.useActivityIframePlannerLazyQuery = useActivityIframePlannerLazyQuery;
exports.useActivityIframePlannerQuery = useActivityIframePlannerQuery;
exports.useActivityPlannerLazyQuery = useActivityPlannerLazyQuery;
exports.useActivityPlannerQuery = useActivityPlannerQuery;
exports.useActivityReviewLazyQuery = useActivityReviewLazyQuery;
exports.useActivityReviewQuery = useActivityReviewQuery;
exports.useActivitySearchLazyQuery = useActivitySearchLazyQuery;
exports.useActivitySearchQuery = useActivitySearchQuery;
exports.useAddFavoriteActivityMutation = useAddFavoriteActivityMutation;
exports.useAddFavoriteCompanyMutation = useAddFavoriteCompanyMutation;
exports.useAddFavoriteRentalUnitMutation = useAddFavoriteRentalUnitMutation;
exports.useAgendaFiltersLazyQuery = useAgendaFiltersLazyQuery;
exports.useAgendaFiltersQuery = useAgendaFiltersQuery;
exports.useAlterBookingMutation = useAlterBookingMutation;
exports.useAlternativesInAccommodationLazyQuery = useAlternativesInAccommodationLazyQuery;
exports.useAlternativesInAccommodationQuery = useAlternativesInAccommodationQuery;
exports.useBookingAlterationPreviewLazyQuery = useBookingAlterationPreviewLazyQuery;
exports.useBookingAlterationPreviewQuery = useBookingAlterationPreviewQuery;
exports.useBookingCancellationPreviewLazyQuery = useBookingCancellationPreviewLazyQuery;
exports.useBookingCancellationPreviewQuery = useBookingCancellationPreviewQuery;
exports.useCancelBookingMutation = useCancelBookingMutation;
exports.useCartStatusLazyQuery = useCartStatusLazyQuery;
exports.useCartStatusQuery = useCartStatusQuery;
exports.useCheckoutCartMutation = useCheckoutCartMutation;
exports.useCheckoutConfirmLazyQuery = useCheckoutConfirmLazyQuery;
exports.useCheckoutConfirmOrderLazyQuery = useCheckoutConfirmOrderLazyQuery;
exports.useCheckoutConfirmOrderQuery = useCheckoutConfirmOrderQuery;
exports.useCheckoutConfirmQuery = useCheckoutConfirmQuery;
exports.useCheckoutDetailsLazyQuery = useCheckoutDetailsLazyQuery;
exports.useCheckoutDetailsMeLazyQuery = useCheckoutDetailsMeLazyQuery;
exports.useCheckoutDetailsMeQuery = useCheckoutDetailsMeQuery;
exports.useCheckoutDetailsQuery = useCheckoutDetailsQuery;
exports.useCheckoutExtrasLazyQuery = useCheckoutExtrasLazyQuery;
exports.useCheckoutExtrasQuery = useCheckoutExtrasQuery;
exports.useCheckoutOrderPageLazyQuery = useCheckoutOrderPageLazyQuery;
exports.useCheckoutOrderPageQuery = useCheckoutOrderPageQuery;
exports.useCheckoutPageLazyQuery = useCheckoutPageLazyQuery;
exports.useCheckoutPageQuery = useCheckoutPageQuery;
exports.useCheckoutPaymentLazyQuery = useCheckoutPaymentLazyQuery;
exports.useCheckoutPaymentOrderLazyQuery = useCheckoutPaymentOrderLazyQuery;
exports.useCheckoutPaymentOrderQuery = useCheckoutPaymentOrderQuery;
exports.useCheckoutPaymentQuery = useCheckoutPaymentQuery;
exports.useCheckoutRedirectRentalUnitLazyQuery = useCheckoutRedirectRentalUnitLazyQuery;
exports.useCheckoutRedirectRentalUnitQuery = useCheckoutRedirectRentalUnitQuery;
exports.useCompanyDetailLazyQuery = useCompanyDetailLazyQuery;
exports.useCompanyDetailQuery = useCompanyDetailQuery;
exports.useCompanyFiltersLazyQuery = useCompanyFiltersLazyQuery;
exports.useCompanyFiltersQuery = useCompanyFiltersQuery;
exports.useCompanySearchLazyQuery = useCompanySearchLazyQuery;
exports.useCompanySearchQuery = useCompanySearchQuery;
exports.useDeskModeLazyQuery = useDeskModeLazyQuery;
exports.useDeskModeQuery = useDeskModeQuery;
exports.useFavoriteButtonLazyQuery = useFavoriteButtonLazyQuery;
exports.useFavoriteButtonQuery = useFavoriteButtonQuery;
exports.useGetCartLazyQuery = useGetCartLazyQuery;
exports.useGetCartQuery = useGetCartQuery;
exports.useLeaveActivityReviewMutation = useLeaveActivityReviewMutation;
exports.useLeaveReviewMutation = useLeaveReviewMutation;
exports.useLeaveUnauthenticatedActivityReviewMutation = useLeaveUnauthenticatedActivityReviewMutation;
exports.useLeaveUnauthenticatedReviewMutation = useLeaveUnauthenticatedReviewMutation;
exports.useMeLazyQuery = useMeLazyQuery;
exports.useMeQuery = useMeQuery;
exports.useMyLazyQuery = useMyLazyQuery;
exports.useMyQuery = useMyQuery;
exports.useOrderDetailsLazyQuery = useOrderDetailsLazyQuery;
exports.useOrderDetailsQuery = useOrderDetailsQuery;
exports.usePayOrderMutation = usePayOrderMutation;
exports.usePlannerPageRentalUnitByIdLazyQuery = usePlannerPageRentalUnitByIdLazyQuery;
exports.usePlannerPageRentalUnitByIdQuery = usePlannerPageRentalUnitByIdQuery;
exports.usePlannerPageRentalUnitLazyQuery = usePlannerPageRentalUnitLazyQuery;
exports.usePlannerPageRentalUnitQuery = usePlannerPageRentalUnitQuery;
exports.useRegisterMutation = useRegisterMutation;
exports.useRemoveFavoriteMutation = useRemoveFavoriteMutation;
exports.useRentalUnitReviewLazyQuery = useRentalUnitReviewLazyQuery;
exports.useRentalUnitReviewQuery = useRentalUnitReviewQuery;
exports.useReviewsLazyQuery = useReviewsLazyQuery;
exports.useReviewsQuery = useReviewsQuery;
exports.useSearchPageRentalUnitsLazyQuery = useSearchPageRentalUnitsLazyQuery;
exports.useSearchPageRentalUnitsQuery = useSearchPageRentalUnitsQuery;
exports.useSearchRentalUnitsLazyQuery = useSearchRentalUnitsLazyQuery;
exports.useSearchRentalUnitsQuery = useSearchRentalUnitsQuery;
exports.useSearchSurchargesLazyQuery = useSearchSurchargesLazyQuery;
exports.useSearchSurchargesQuery = useSearchSurchargesQuery;
exports.useSearchTripsLazyQuery = useSearchTripsLazyQuery;
exports.useSearchTripsQuery = useSearchTripsQuery;
exports.useSendAuthenticationEmailMutation = useSendAuthenticationEmailMutation;
exports.useSetCartExtrasMutation = useSetCartExtrasMutation;
exports.useSetCartMutation = useSetCartMutation;
exports.useSpecialLazyQuery = useSpecialLazyQuery;
exports.useSpecialQuery = useSpecialQuery;
exports.useTorSitemapLazyQuery = useTorSitemapLazyQuery;
exports.useTorSitemapQuery = useTorSitemapQuery;
exports.useTripPlannerLazyQuery = useTripPlannerLazyQuery;
exports.useTripPlannerQuery = useTripPlannerQuery;
exports.useUnitDetailInitialTripsLazyQuery = useUnitDetailInitialTripsLazyQuery;
exports.useUnitDetailInitialTripsQuery = useUnitDetailInitialTripsQuery;
exports.useUnitDetailsLazyQuery = useUnitDetailsLazyQuery;
exports.useUnitDetailsQuery = useUnitDetailsQuery;
exports.useUnitDetailsSearchLazyQuery = useUnitDetailsSearchLazyQuery;
exports.useUnitDetailsSearchQuery = useUnitDetailsSearchQuery;
exports.useUnitFilterPropertiesLazyQuery = useUnitFilterPropertiesLazyQuery;
exports.useUnitFilterPropertiesQuery = useUnitFilterPropertiesQuery;
exports.useUnitRelevantAlternativesLazyQuery = useUnitRelevantAlternativesLazyQuery;
exports.useUnitRelevantAlternativesQuery = useUnitRelevantAlternativesQuery;
exports.useUnitSearchAlternativeDatesLazyQuery = useUnitSearchAlternativeDatesLazyQuery;
exports.useUnitSearchAlternativeDatesQuery = useUnitSearchAlternativeDatesQuery;
exports.useUnitSearchPriceFilterLazyQuery = useUnitSearchPriceFilterLazyQuery;
exports.useUnitSearchPriceFilterQuery = useUnitSearchPriceFilterQuery;
exports.useUpdateCartFromDetailsMutation = useUpdateCartFromDetailsMutation;
exports.useUpdateCartMutation = useUpdateCartMutation;
exports.useUpdateCustomerMutation = useUpdateCustomerMutation;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _client = require("@apollo/client");
var ApolloReactHooks = _interopRequireWildcard(require("../apollo"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable */ /* tslint:disable */
(0, _client.disableFragmentWarnings)();
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

/**
 *   An Accommodation is a representation of a location which can contain one or more RentalUnits.
 *  For example: a hotel would be represented by an Accommodation with each room type represented by a separate RentalUnit.
 */

/**
 *   An Accommodation is a representation of a location which can contain one or more RentalUnits.
 *  For example: a hotel would be represented by an Accommodation with each room type represented by a separate RentalUnit.
 */

/**   An image file available through a CDN URL. */

/**   An image file available through a CDN URL. */
/**   Categories for AccommodationImages, describing what the image displays. */
let AccommodationImageCategoryEnum = exports.AccommodationImageCategoryEnum = /*#__PURE__*/function (AccommodationImageCategoryEnum) {
  AccommodationImageCategoryEnum["Bathroom"] = "BATHROOM";
  AccommodationImageCategoryEnum["Bedroom"] = "BEDROOM";
  AccommodationImageCategoryEnum["Entrance"] = "ENTRANCE";
  AccommodationImageCategoryEnum["Facilities"] = "FACILITIES";
  AccommodationImageCategoryEnum["FloorPlan"] = "FLOOR_PLAN";
  AccommodationImageCategoryEnum["Front"] = "FRONT";
  AccommodationImageCategoryEnum["Kitchen"] = "KITCHEN";
  AccommodationImageCategoryEnum["LivingRoom"] = "LIVING_ROOM";
  AccommodationImageCategoryEnum["Other"] = "OTHER";
  AccommodationImageCategoryEnum["Outdoor"] = "OUTDOOR";
  AccommodationImageCategoryEnum["Surroundings"] = "SURROUNDINGS";
  AccommodationImageCategoryEnum["View"] = "VIEW";
  return AccommodationImageCategoryEnum;
}({});
/**   Types of Accommodation. */
let AccommodationTypeEnum = exports.AccommodationTypeEnum = /*#__PURE__*/function (AccommodationTypeEnum) {
  AccommodationTypeEnum["ApartmentBlock"] = "APARTMENT_BLOCK";
  AccommodationTypeEnum["BedAndBreakfast"] = "BED_AND_BREAKFAST";
  AccommodationTypeEnum["BungalowPark"] = "BUNGALOW_PARK";
  AccommodationTypeEnum["Camping"] = "CAMPING";
  AccommodationTypeEnum["Hotel"] = "HOTEL";
  AccommodationTypeEnum["Location"] = "LOCATION";
  return AccommodationTypeEnum;
}({});
/**   Activity booking types */
let ActivityBookingTypesEnum = exports.ActivityBookingTypesEnum = /*#__PURE__*/function (ActivityBookingTypesEnum) {
  ActivityBookingTypesEnum["Direct"] = "DIRECT";
  ActivityBookingTypesEnum["External"] = "EXTERNAL";
  ActivityBookingTypesEnum["NotBookable"] = "NOT_BOOKABLE";
  return ActivityBookingTypesEnum;
}({});
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   A review of a Activity submitted by a Customer. */
/**   Summary of the ActivityReviews submitted. */
/**   Activity search result ordering options. */
let ActivitySearchOrderEnum = exports.ActivitySearchOrderEnum = /*#__PURE__*/function (ActivitySearchOrderEnum) {
  ActivitySearchOrderEnum["Random"] = "RANDOM";
  ActivitySearchOrderEnum["ReviewRatingDesc"] = "REVIEW_RATING_DESC";
  ActivitySearchOrderEnum["TimeslotsAsc"] = "TIMESLOTS_ASC";
  return ActivitySearchOrderEnum;
}({});
/**   An attribute which is assigned to either an Accommodation or a RentalUnit. */
/**   A category for Attributes. */
let BookingStatus = exports.BookingStatus = /*#__PURE__*/function (BookingStatus) {
  BookingStatus["Accepted"] = "ACCEPTED";
  BookingStatus["CancelledExternal"] = "CANCELLED_EXTERNAL";
  BookingStatus["CancelledGuest"] = "CANCELLED_GUEST";
  BookingStatus["CancelledPartner"] = "CANCELLED_PARTNER";
  BookingStatus["Declined"] = "DECLINED";
  BookingStatus["Init"] = "INIT";
  BookingStatus["NoShow"] = "NO_SHOW";
  BookingStatus["Pending"] = "PENDING";
  BookingStatus["Waived"] = "WAIVED";
  return BookingStatus;
}({});
/**   A bounding box of GPS coordinates. */
let CartStatusEnum = exports.CartStatusEnum = /*#__PURE__*/function (CartStatusEnum) {
  CartStatusEnum["Closed"] = "CLOSED";
  CartStatusEnum["Open"] = "OPEN";
  CartStatusEnum["PaymentFailed"] = "PAYMENT_FAILED";
  CartStatusEnum["PaymentPending"] = "PAYMENT_PENDING";
  return CartStatusEnum;
}({});
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   An image file available through a CDN URL. */
/**   A version of an image transformed according to the requested parameters. */
/**   Available image transform configurations. This determines the scaling method and the generated sizes. */
let ImageTransformConfigEnum = exports.ImageTransformConfigEnum = /*#__PURE__*/function (ImageTransformConfigEnum) {
  ImageTransformConfigEnum["Avatar"] = "AVATAR";
  ImageTransformConfigEnum["Gallery"] = "GALLERY";
  ImageTransformConfigEnum["Hero"] = "HERO";
  ImageTransformConfigEnum["Logo"] = "LOGO";
  ImageTransformConfigEnum["Tile"] = "TILE";
  return ImageTransformConfigEnum;
}({});
/**
 *   Available image formats for transforms. Use WebP whenever possible for lowest image size.
 *  Note that not all formats are available for every transform.
 */
let ImageTransformFormatEnum = exports.ImageTransformFormatEnum = /*#__PURE__*/function (ImageTransformFormatEnum) {
  ImageTransformFormatEnum["Jpeg"] = "JPEG";
  ImageTransformFormatEnum["Png"] = "PNG";
  ImageTransformFormatEnum["Webp"] = "WEBP";
  return ImageTransformFormatEnum;
}({});
/**   A set of GPS coordinates. */
/**   A set of GPS coordinates. */
let PaymentMethodEnum = exports.PaymentMethodEnum = /*#__PURE__*/function (PaymentMethodEnum) {
  PaymentMethodEnum["ApplePay"] = "APPLE_PAY";
  PaymentMethodEnum["Bancontact"] = "BANCONTACT";
  PaymentMethodEnum["BankAccount"] = "BANK_ACCOUNT";
  PaymentMethodEnum["Cash"] = "CASH";
  PaymentMethodEnum["CreditCard"] = "CREDIT_CARD";
  PaymentMethodEnum["CreditNote"] = "CREDIT_NOTE";
  PaymentMethodEnum["DeskBooking"] = "DESK_BOOKING";
  PaymentMethodEnum["GiftCard"] = "GIFT_CARD";
  PaymentMethodEnum["Giropay"] = "GIROPAY";
  PaymentMethodEnum["Ideal"] = "IDEAL";
  PaymentMethodEnum["IngHomepay"] = "ING_HOMEPAY";
  PaymentMethodEnum["None"] = "NONE";
  PaymentMethodEnum["Other"] = "OTHER";
  PaymentMethodEnum["Paypal"] = "PAYPAL";
  PaymentMethodEnum["PointOfSale"] = "POINT_OF_SALE";
  PaymentMethodEnum["SepaDirectDebit"] = "SEPA_DIRECT_DEBIT";
  PaymentMethodEnum["SepaTransfer"] = "SEPA_TRANSFER";
  PaymentMethodEnum["Sofort"] = "SOFORT";
  PaymentMethodEnum["Trustly"] = "TRUSTLY";
  return PaymentMethodEnum;
}({});
let PaymentStatusEnum = exports.PaymentStatusEnum = /*#__PURE__*/function (PaymentStatusEnum) {
  PaymentStatusEnum["Completed"] = "COMPLETED";
  PaymentStatusEnum["Failed"] = "FAILED";
  PaymentStatusEnum["Initializing"] = "INITIALIZING";
  PaymentStatusEnum["Pending"] = "PENDING";
  PaymentStatusEnum["Provisional"] = "PROVISIONAL";
  return PaymentStatusEnum;
}({});
/**   Description of a POI and the distance to it from the parent object. */
let PriceLineCategoryEnum = exports.PriceLineCategoryEnum = /*#__PURE__*/function (PriceLineCategoryEnum) {
  PriceLineCategoryEnum["Accommodation"] = "ACCOMMODATION";
  PriceLineCategoryEnum["AdminCosts"] = "ADMIN_COSTS";
  PriceLineCategoryEnum["Charges"] = "CHARGES";
  PriceLineCategoryEnum["Insurance"] = "INSURANCE";
  PriceLineCategoryEnum["NotInTotal"] = "NOT_IN_TOTAL";
  PriceLineCategoryEnum["Special"] = "SPECIAL";
  PriceLineCategoryEnum["Surcharges"] = "SURCHARGES";
  return PriceLineCategoryEnum;
}({});
/**   Properties to filter by in a search query. */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**
 *   This is a representation of a specific (type of) rental object within an Accommodation.
 *  For example: a 2-person hotel room with ocean view (of which there are multiple) or a privately owned vacation home (of which there is only one).
 */
/**   Types of RentalUnit. */
let RentalUnitTypeEnum = exports.RentalUnitTypeEnum = /*#__PURE__*/function (RentalUnitTypeEnum) {
  RentalUnitTypeEnum["Bed"] = "BED";
  RentalUnitTypeEnum["Boat"] = "BOAT";
  RentalUnitTypeEnum["CamperSpot"] = "CAMPER_SPOT";
  RentalUnitTypeEnum["CampingPitch"] = "CAMPING_PITCH";
  RentalUnitTypeEnum["Home"] = "HOME";
  RentalUnitTypeEnum["Room"] = "ROOM";
  RentalUnitTypeEnum["Tent"] = "TENT";
  return RentalUnitTypeEnum;
}({});
/**   A review of a RentalUnit submitted by a Customer. */
/**   Summary of the Reviews submitted. */
/**   RentalUnit search result ordering options. */
let SearchRentalUnitsOrderEnum = exports.SearchRentalUnitsOrderEnum = /*#__PURE__*/function (SearchRentalUnitsOrderEnum) {
  SearchRentalUnitsOrderEnum["RandomBoosted"] = "RANDOM_BOOSTED";
  SearchRentalUnitsOrderEnum["RecentBookingsBoosted"] = "RECENT_BOOKINGS_BOOSTED";
  SearchRentalUnitsOrderEnum["ReviewRatingDesc"] = "REVIEW_RATING_DESC";
  return SearchRentalUnitsOrderEnum;
}({});
/**   Results of a RentalUnit search query. */
/**   The results of a search within Trips. */
/**   The results of a search within Trips. */
/**   Statistics for a specific search whitin Trips. */
let SurchargeCalculationEnum = exports.SurchargeCalculationEnum = /*#__PURE__*/function (SurchargeCalculationEnum) {
  SurchargeCalculationEnum["PerPerson"] = "PER_PERSON";
  SurchargeCalculationEnum["PerPersonPerNight"] = "PER_PERSON_PER_NIGHT";
  SurchargeCalculationEnum["PerPet"] = "PER_PET";
  SurchargeCalculationEnum["PerPetPerNight"] = "PER_PET_PER_NIGHT";
  SurchargeCalculationEnum["PerPiece"] = "PER_PIECE";
  SurchargeCalculationEnum["PerPiecePerNight"] = "PER_PIECE_PER_NIGHT";
  SurchargeCalculationEnum["Subsequent"] = "SUBSEQUENT";
  return SurchargeCalculationEnum;
}({});
/**   Available target audience options. */
let TargetAudienceEnum = exports.TargetAudienceEnum = /*#__PURE__*/function (TargetAudienceEnum) {
  TargetAudienceEnum["Adults"] = "ADULTS";
  TargetAudienceEnum["AllAges"] = "ALL_AGES";
  TargetAudienceEnum["Children"] = "CHILDREN";
  TargetAudienceEnum["Pets"] = "PETS";
  TargetAudienceEnum["WheelchairAccessible"] = "WHEELCHAIR_ACCESSIBLE";
  return TargetAudienceEnum;
}({});
let TicketStatus = exports.TicketStatus = /*#__PURE__*/function (TicketStatus) {
  TicketStatus["Accepted"] = "ACCEPTED";
  TicketStatus["Init"] = "INIT";
  TicketStatus["Waived"] = "WAIVED";
  return TicketStatus;
}({});
let TravelGroupType = exports.TravelGroupType = /*#__PURE__*/function (TravelGroupType) {
  TravelGroupType["Alone"] = "ALONE";
  TravelGroupType["BusinessTrip"] = "BUSINESS_TRIP";
  TravelGroupType["FamilyWithOlderChildren"] = "FAMILY_WITH_OLDER_CHILDREN";
  TravelGroupType["FamilyWithYoungChildren"] = "FAMILY_WITH_YOUNG_CHILDREN";
  TravelGroupType["GroupOfFriends"] = "GROUP_OF_FRIENDS";
  TravelGroupType["GroupTrip"] = "GROUP_TRIP";
  TravelGroupType["OlderCouple"] = "OLDER_COUPLE";
  TravelGroupType["YoungCouple"] = "YOUNG_COUPLE";
  return TravelGroupType;
}({});
/**   Available types of Trip. */
let TripTypeEnum = exports.TripTypeEnum = /*#__PURE__*/function (TripTypeEnum) {
  TripTypeEnum["EarlyBooking"] = "EARLY_BOOKING";
  TripTypeEnum["LastMinute"] = "LAST_MINUTE";
  TripTypeEnum["Regular"] = "REGULAR";
  TripTypeEnum["Special"] = "SPECIAL";
  return TripTypeEnum;
}({});
/**   A property of a RentalUnit or Accommodation which can be used to filter by. */
/**   A category of FilterProperties. */
/**   RentalUnit/Trip search result ordering options. */
let UnitSearchOrderEnum = exports.UnitSearchOrderEnum = /*#__PURE__*/function (UnitSearchOrderEnum) {
  UnitSearchOrderEnum["PriceAsc"] = "PRICE_ASC";
  UnitSearchOrderEnum["PriceDesc"] = "PRICE_DESC";
  UnitSearchOrderEnum["RandomBoosted"] = "RANDOM_BOOSTED";
  UnitSearchOrderEnum["RecentBookingsBoosted"] = "RECENT_BOOKINGS_BOOSTED";
  UnitSearchOrderEnum["ReviewRatingDesc"] = "REVIEW_RATING_DESC";
  return UnitSearchOrderEnum;
}({});
/**   Parameters for searching within RentalUnits (optionally filtered by specific Trip availability). */
/**   Results of a RentalUnit/Trip search query. */
let UpsellPurchaseStatus = exports.UpsellPurchaseStatus = /*#__PURE__*/function (UpsellPurchaseStatus) {
  UpsellPurchaseStatus["Accepted"] = "ACCEPTED";
  UpsellPurchaseStatus["Init"] = "INIT";
  UpsellPurchaseStatus["Waived"] = "WAIVED";
  return UpsellPurchaseStatus;
}({});
const TimeOpenClosedFragmentDoc = exports.TimeOpenClosedFragmentDoc = (0, _client.gql)`
    fragment TimeOpenClosed on TimeOpenClosed {
  timeOpen
  timeClosed
}
    `;
const CompanyOperatingHoursFragmentDoc = exports.CompanyOperatingHoursFragmentDoc = (0, _client.gql)`
    fragment CompanyOperatingHours on Company {
  normalOperatingHours {
    monday {
      ...TimeOpenClosed
    }
    tuesday {
      ...TimeOpenClosed
    }
    wednesday {
      ...TimeOpenClosed
    }
    thursday {
      ...TimeOpenClosed
    }
    friday {
      ...TimeOpenClosed
    }
    saturday {
      ...TimeOpenClosed
    }
    sunday {
      ...TimeOpenClosed
    }
  }
  specialOperatingHours {
    startDate
    endDate
    monday {
      ...TimeOpenClosed
    }
    tuesday {
      ...TimeOpenClosed
    }
    wednesday {
      ...TimeOpenClosed
    }
    thursday {
      ...TimeOpenClosed
    }
    friday {
      ...TimeOpenClosed
    }
    saturday {
      ...TimeOpenClosed
    }
    sunday {
      ...TimeOpenClosed
    }
  }
}
    ${TimeOpenClosedFragmentDoc}`;
const ActivityPlannerActivityFragmentDoc = exports.ActivityPlannerActivityFragmentDoc = (0, _client.gql)`
    fragment ActivityPlannerActivity on Activity {
  name
  bookingType
  externalBookingUrl
  company {
    ...CompanyOperatingHours
  }
}
    ${CompanyOperatingHoursFragmentDoc}`;
const CheckoutPaymentsBookingFragmentDoc = exports.CheckoutPaymentsBookingFragmentDoc = (0, _client.gql)`
    fragment CheckoutPaymentsBooking on Booking {
  rentalUnit {
    id
    name
    accommodation {
      id
      checkInEndTime
      checkInStartTime
      checkOutTime
    }
  }
}
    `;
const PaymentFragmentDoc = exports.PaymentFragmentDoc = (0, _client.gql)`
    fragment Payment on Payment {
  amount
  date
  status
}
    `;
const ExtrasFragmentDoc = exports.ExtrasFragmentDoc = (0, _client.gql)`
    fragment Extras on AttributeCategory {
  name
  handle
  attributes {
    id
    name
    iconUrl
    handle
  }
}
    `;
const LocationFragmentDoc = exports.LocationFragmentDoc = (0, _client.gql)`
    fragment Location on Accommodation {
  descriptionLocation
  pointsOfInterest {
    name
    distance
  }
  coordinates {
    lat
    lon
  }
}
    `;
const SpecialCountFragmentDoc = exports.SpecialCountFragmentDoc = (0, _client.gql)`
    fragment SpecialCount on UnitSearchResult {
  specialCounts {
    special {
      description
      id
      landingPageUrl
      name
    }
    hits
  }
}
    `;
const TripTypeCountFragmentDoc = exports.TripTypeCountFragmentDoc = (0, _client.gql)`
    fragment TripTypeCount on UnitSearchResult {
  tripTypeCounts {
    hits
    tripType
  }
}
    `;
const UnitReviewsFragmentDoc = exports.UnitReviewsFragmentDoc = (0, _client.gql)`
    fragment UnitReviews on Review {
  id
  title
  average
  city
  date
  comment
  reply
}
    `;
const ActivityReviewsFragmentDoc = exports.ActivityReviewsFragmentDoc = (0, _client.gql)`
    fragment ActivityReviews on ActivityReview {
  id
  title
  average
  city
  date
  comment
  reply
}
    `;
const ListImageFragmentDoc = exports.ListImageFragmentDoc = (0, _client.gql)`
    fragment ListImage on ImageTransform {
  placeholder
  srcSet
  src
  ratio
}
    `;
const SearchHitRentalUnitFragmentDoc = exports.SearchHitRentalUnitFragmentDoc = (0, _client.gql)`
    fragment SearchHitRentalUnit on RentalUnit {
  id
  name
  slug
  type
  code
  brand
  amountBedrooms
  maxOccupancy
  flexCancellationDays
  hasBadge: hasFilterProperty(handle: $badgeHandle)
  hasbadge2: hasFilterProperty(handle: $badge2Handle)
  reviewStats {
    count
    average
  }
  mainImage {
    transform(config: HERO, format: WEBP) {
      src
    }
  }
  webpListImage: listImage {
    transform(config: TILE, format: WEBP) {
      ...ListImage
    }
  }
  listImage {
    transform(config: TILE, format: JPEG) {
      ...ListImage
    }
  }
  accommodation {
    id
    place
    address {
      city
    }
    name
    hasPublicPage
    collapseInSearch
    coordinates {
      lat
      lon
    }
  }
  tagline
  fullCircleImageUrl
  videoUrl
}
    ${ListImageFragmentDoc}`;
const SearchHitTripFragmentDoc = exports.SearchHitTripFragmentDoc = (0, _client.gql)`
    fragment SearchHitTrip on Trip {
  originalPrice
  date
  duration
  price
  type
  special {
    id
    name
    description
    landingPageUrl
  }
}
    `;
const SearchHitFragmentDoc = exports.SearchHitFragmentDoc = (0, _client.gql)`
    fragment SearchHit on UnitSearchHit {
  rentalUnit {
    ...SearchHitRentalUnit
  }
  trips {
    ...SearchHitTrip
  }
}
    ${SearchHitRentalUnitFragmentDoc}
${SearchHitTripFragmentDoc}`;
const SearchRentalUnitsFragmentDoc = exports.SearchRentalUnitsFragmentDoc = (0, _client.gql)`
    fragment SearchRentalUnits on UnitSearchResult {
  totalHits
  hits {
    ...SearchHit
  }
}
    ${SearchHitFragmentDoc}`;
const UnitFilterPropertyCategoryFragmentDoc = exports.UnitFilterPropertyCategoryFragmentDoc = (0, _client.gql)`
    fragment UnitFilterPropertyCategory on UnitFilterPropertyCategory {
  name
  handle
  filterProperties {
    name
    handle
  }
}
    `;
const TransformFragmentDoc = exports.TransformFragmentDoc = (0, _client.gql)`
    fragment Transform on ImageTransform {
  placeholder
  srcSet
  src
  ratio
}
    `;
const UnitAccommodationFragmentDoc = exports.UnitAccommodationFragmentDoc = (0, _client.gql)`
    fragment UnitAccommodation on Accommodation {
  slug
  jpegMain: mainImage {
    transform(config: HERO, format: JPEG) {
      ...Transform
    }
  }
  webpMain: mainImage {
    transform(config: HERO, format: WEBP) {
      ...Transform
    }
  }
  descriptionGeneral
  name
}
    ${TransformFragmentDoc}`;
const UnitFeaturesFragmentDoc = exports.UnitFeaturesFragmentDoc = (0, _client.gql)`
    fragment UnitFeatures on RentalUnit {
  livingArea
  outdoorArea
  maxOccupancy
  amountBedrooms
  petsAllowed
  amountBathrooms
  amountToilets
  code
  type
  accommodation {
    place
  }
}
    `;
const UnitOwnerFragmentDoc = exports.UnitOwnerFragmentDoc = (0, _client.gql)`
    fragment UnitOwner on Accommodation {
  jpegOwner: ownerImage {
    transform(config: AVATAR, format: JPEG) {
      ...Transform
    }
  }
  webpOwner: ownerImage {
    transform(config: AVATAR, format: WEBP) {
      ...Transform
    }
  }
  ownerIntroduction
  ownerName
  ownerTips
}
    ${TransformFragmentDoc}`;
const ImagesFragmentDoc = exports.ImagesFragmentDoc = (0, _client.gql)`
    fragment Images on AccommodationImage {
  category
  jpegTile: transform(config: TILE, format: JPEG) {
    ...Transform
  }
  webpTile: transform(config: TILE, format: WEBP) {
    ...Transform
  }
  jpegGallery: transform(config: GALLERY, format: JPEG) {
    ...Transform
  }
  webpGallery: transform(config: GALLERY, format: WEBP) {
    ...Transform
  }
}
    ${TransformFragmentDoc}`;
const UnitPhotosFragmentDoc = exports.UnitPhotosFragmentDoc = (0, _client.gql)`
    fragment UnitPhotos on RentalUnit {
  images {
    ...Images
  }
}
    ${ImagesFragmentDoc}`;
const AccommodationPhotosFragmentDoc = exports.AccommodationPhotosFragmentDoc = (0, _client.gql)`
    fragment AccommodationPhotos on Accommodation {
  images {
    ...Images
  }
}
    ${ImagesFragmentDoc}`;
const UnitRelevantAlternativesFragmentDoc = exports.UnitRelevantAlternativesFragmentDoc = (0, _client.gql)`
    fragment UnitRelevantAlternatives on UnitSearchResult {
  hits {
    ...SearchHit
  }
}
    ${SearchHitFragmentDoc}`;
const LeaveActivityReviewsFragmentDoc = exports.LeaveActivityReviewsFragmentDoc = (0, _client.gql)`
    fragment LeaveActivityReviews on Activity {
  id
  name
  slug
  minCapacity
  maxCapacity
  jpegThumbnail: listImage {
    transform(config: TILE, format: JPEG) {
      ...Transform
    }
  }
  webpThumbnail: listImage {
    transform(config: TILE, format: WEBP) {
      ...Transform
    }
  }
}
    ${TransformFragmentDoc}`;
const ActivityPlannerTimeslotFragmentDoc = exports.ActivityPlannerTimeslotFragmentDoc = (0, _client.gql)`
    fragment ActivityPlannerTimeslot on Timeslot {
  id
  allotment
  startDateTime
  endDateTime
  label
  rateGroup {
    releaseHours
    rates {
      id
      name
      price
    }
  }
}
    `;
const ActivityHitFragmentDoc = exports.ActivityHitFragmentDoc = (0, _client.gql)`
    fragment ActivityHit on Activity {
  id
  name
  slug
  highlighted
  place
  videoUrl
  externalBookingUrl
  bookingType
  themes {
    slug
    name
  }
  activityReviewStats {
    count
    average
  }
  minCapacity
  maxCapacity
  timeslots(startDate: $startDate, endDate: $endDate) {
    ...ActivityPlannerTimeslot
  }
  themes {
    slug
  }
  mainImage {
    transform(config: HERO, format: JPEG) {
      ...ListImage
    }
  }
  webpMainImage: mainImage {
    transform(config: HERO, format: WEBP) {
      ...ListImage
    }
  }
  webpListImage: listImage {
    transform(config: HERO, format: WEBP) {
      ...ListImage
    }
  }
  listImage {
    transform(config: HERO, format: JPEG) {
      ...ListImage
    }
  }
}
    ${ActivityPlannerTimeslotFragmentDoc}
${ListImageFragmentDoc}`;
const RentalUnitReviewFragmentDoc = exports.RentalUnitReviewFragmentDoc = (0, _client.gql)`
    fragment RentalUnitReview on RentalUnit {
  id
  code
  name
  slug
  maxOccupancy
  minOccupancy
  petsAllowed
  accommodation {
    id
    hasPublicPage
    name
    checkInEndTime
    checkInStartTime
    checkOutTime
    type
  }
  type
  jpegThumbnail: listImage {
    transform(config: TILE, format: JPEG) {
      ...Transform
    }
  }
  webpThumbnail: listImage {
    transform(config: TILE, format: WEBP) {
      ...Transform
    }
  }
}
    ${TransformFragmentDoc}`;
const AddressFragmentDoc = exports.AddressFragmentDoc = (0, _client.gql)`
    fragment Address on Address {
  city
  countryCode
  number
  postalCode
  street
}
    `;
const OrderCustomerInfoFragmentDoc = exports.OrderCustomerInfoFragmentDoc = (0, _client.gql)`
    fragment OrderCustomerInfo on Customer {
  email
  phoneNumber
  firstName
  lastName
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
const CheckoutConfirmTicketFragmentDoc = exports.CheckoutConfirmTicketFragmentDoc = (0, _client.gql)`
    fragment CheckoutConfirmTicket on Ticket {
  startDateTime
  endDateTime
  activity {
    id
    name
  }
}
    `;
const CheckoutConfirmBookingFragmentDoc = exports.CheckoutConfirmBookingFragmentDoc = (0, _client.gql)`
    fragment CheckoutConfirmBooking on Booking {
  rentalUnit {
    id
    code
    name
    slug
    maxOccupancy
    minOccupancy
    petsAllowed
    accommodation {
      id
      hasPublicPage
      name
      checkInEndTime
      checkInStartTime
      checkOutTime
      type
    }
    type
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
  }
}
    ${TransformFragmentDoc}`;
const CartTicketFragmentDoc = exports.CartTicketFragmentDoc = (0, _client.gql)`
    fragment CartTicket on Ticket {
  ticketStatus: status
  startDateTime
  activity {
    id
    slug
  }
  timeslot {
    ...ActivityPlannerTimeslot
  }
  rateLines {
    amount
    rateId
    totalPrice
    unitPrice
  }
}
    ${ActivityPlannerTimeslotFragmentDoc}`;
const CartBookingFragmentDoc = exports.CartBookingFragmentDoc = (0, _client.gql)`
    fragment CartBooking on Booking {
  status
  amountAdults
  amountPets
  amountChildren
  amountBabies
  amountYouths
  arrivalDate
  departureDate
  hasCancellationInsurance
  hasContentsInsurance
  handleDepositPayment
  deposit
  requiresApproval
  paymentPrice
  rentalUnit {
    id
  }
  special {
    id
  }
  optionalSurcharges {
    rentalUnitSurchargeId
    amount
  }
}
    `;
const CartUpsellFragmentDoc = exports.CartUpsellFragmentDoc = (0, _client.gql)`
    fragment CartUpsell on UpsellPurchase {
  priceLines {
    label
    quantity
    totalPrice
    unitPrice
    category
  }
  offer {
    id
  }
  totalPrice
  paymentPrice
  amount
}
    `;
const CartOrderItemFragmentDoc = exports.CartOrderItemFragmentDoc = (0, _client.gql)`
    fragment CartOrderItem on OrderItem {
  priceLines {
    label
    quantity
    totalPrice
    unitPrice
    category
  }
  totalPrice
  paymentPrice
  errors
  ...CartTicket
  ...CartBooking
  ...CartUpsell
}
    ${CartTicketFragmentDoc}
${CartBookingFragmentDoc}
${CartUpsellFragmentDoc}`;
const CheckoutConfirmOrderItemFragmentDoc = exports.CheckoutConfirmOrderItemFragmentDoc = (0, _client.gql)`
    fragment CheckoutConfirmOrderItem on OrderItem {
  ...CheckoutConfirmTicket
  ...CheckoutConfirmBooking
  ...CartOrderItem
}
    ${CheckoutConfirmTicketFragmentDoc}
${CheckoutConfirmBookingFragmentDoc}
${CartOrderItemFragmentDoc}`;
const ActivityCheckoutModalTimeslotFragmentDoc = exports.ActivityCheckoutModalTimeslotFragmentDoc = (0, _client.gql)`
    fragment ActivityCheckoutModalTimeslot on Timeslot {
  id
  startDateTime
  endDateTime
  allotment
  rateGroup {
    rates {
      id
      name
      price
    }
  }
}
    `;
const CheckoutExtrasTicketFragmentDoc = exports.CheckoutExtrasTicketFragmentDoc = (0, _client.gql)`
    fragment CheckoutExtrasTicket on Ticket {
  activity {
    id
    name
    slug
    descriptionParticulars
    bookingType
    company {
      id
      ...CompanyOperatingHours
    }
  }
  startDateTime
  endDateTime
  timeslot {
    ...ActivityCheckoutModalTimeslot
  }
  rateLines {
    amount
  }
}
    ${CompanyOperatingHoursFragmentDoc}
${ActivityCheckoutModalTimeslotFragmentDoc}`;
const CheckoutExtrasBookingRentalUnitFragmentDoc = exports.CheckoutExtrasBookingRentalUnitFragmentDoc = (0, _client.gql)`
    fragment CheckoutExtrasBookingRentalUnit on RentalUnit {
  id
  slug
  name
  type
  amountBedrooms
  maxOccupancy
  minOccupancy
  maxExtraBabyOccupancy
  flexCancellationDays
  petsAllowed
  descriptionParticulars
  contentsInsuranceAvailable
  cancellationInsuranceAvailable
  accommodation {
    hasPublicPage
    name
    id
    hasPublicPage
    checkInStartTime
    checkInEndTime
    checkOutTime
  }
}
    `;
const CheckoutExtrasBookingFragmentDoc = exports.CheckoutExtrasBookingFragmentDoc = (0, _client.gql)`
    fragment CheckoutExtrasBooking on Booking {
  special {
    id
    name
    description
  }
  rentalUnit {
    ...CheckoutExtrasBookingRentalUnit
  }
  hasCancellationInsurance
  hasContentsInsurance
  optionalSurcharges {
    rentalUnitSurchargeId
    amount
  }
}
    ${CheckoutExtrasBookingRentalUnitFragmentDoc}`;
const CheckoutExtrasOrderItemFragmentDoc = exports.CheckoutExtrasOrderItemFragmentDoc = (0, _client.gql)`
    fragment CheckoutExtrasOrderItem on OrderItem {
  ...CheckoutExtrasTicket
  ...CheckoutExtrasBooking
  ...CartOrderItem
}
    ${CheckoutExtrasTicketFragmentDoc}
${CheckoutExtrasBookingFragmentDoc}
${CartOrderItemFragmentDoc}`;
const CustomerDetailsFragmentDoc = exports.CustomerDetailsFragmentDoc = (0, _client.gql)`
    fragment CustomerDetails on Customer {
  phoneNumber
  firstName
  lastName
  email
  birthdate
  address {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
const CheckoutDetailsCustomerInfoFragmentDoc = exports.CheckoutDetailsCustomerInfoFragmentDoc = (0, _client.gql)`
    fragment CheckoutDetailsCustomerInfo on Order {
  customer {
    ...CustomerDetails
  }
  agreedToTerms
  newsletterOptin
}
    ${CustomerDetailsFragmentDoc}`;
const OrderMetaFragmentDoc = exports.OrderMetaFragmentDoc = (0, _client.gql)`
    fragment OrderMeta on Order {
  number
  errors
  totalPrice
  paymentOptions {
    totalAmountDue
    partialPaymentAmount
  }
}
    `;
const CheckoutDetailsFragmentDoc = exports.CheckoutDetailsFragmentDoc = (0, _client.gql)`
    fragment CheckoutDetails on Cart {
  id
  status
  order {
    isDeskOrder
    orderItems {
      ...CheckoutExtrasOrderItem
    }
    ...CheckoutDetailsCustomerInfo
    ...OrderMeta
  }
}
    ${CheckoutExtrasOrderItemFragmentDoc}
${CheckoutDetailsCustomerInfoFragmentDoc}
${OrderMetaFragmentDoc}`;
const CheckoutExtrasFragmentDoc = exports.CheckoutExtrasFragmentDoc = (0, _client.gql)`
    fragment CheckoutExtras on Cart {
  id
  status
  availableUpsellOffers {
    id
    name
    unitPrice
    maxAmount
    description
  }
  order {
    orderItems {
      ...CheckoutExtrasOrderItem
    }
    ...OrderMeta
  }
}
    ${CheckoutExtrasOrderItemFragmentDoc}
${OrderMetaFragmentDoc}`;
const CheckoutPaymentBookingFragmentDoc = exports.CheckoutPaymentBookingFragmentDoc = (0, _client.gql)`
    fragment CheckoutPaymentBooking on Booking {
  hasCancellationInsurance
  hasContentsInsurance
  arrivalDate
  departureDate
  optionalSurcharges {
    amount
    rentalUnitSurchargeId
  }
  rentalUnit {
    id
    name
    code
    type
    accommodation {
      id
      name
      type
      checkInEndTime
      checkInStartTime
      checkOutTime
    }
  }
}
    `;
const CheckoutPaymentTicketFragmentDoc = exports.CheckoutPaymentTicketFragmentDoc = (0, _client.gql)`
    fragment CheckoutPaymentTicket on Ticket {
  timeslot {
    id
    startDateTime
    endDateTime
    rateGroup {
      rates {
        id
        name
        price
      }
    }
  }
  activity {
    id
    name
  }
}
    `;
const CheckoutPaymentOrderItemFragmentDoc = exports.CheckoutPaymentOrderItemFragmentDoc = (0, _client.gql)`
    fragment CheckoutPaymentOrderItem on OrderItem {
  ...CheckoutPaymentBooking
  ...CheckoutPaymentTicket
  ...CartOrderItem
}
    ${CheckoutPaymentBookingFragmentDoc}
${CheckoutPaymentTicketFragmentDoc}
${CartOrderItemFragmentDoc}`;
const CheckoutPaymentFragmentDoc = exports.CheckoutPaymentFragmentDoc = (0, _client.gql)`
    fragment CheckoutPayment on Cart {
  id
  status
  order {
    number
    isDeskOrder
    orderItems {
      ...CheckoutPaymentOrderItem
      ... on Booking {
        arrivalDate
        departureDate
      }
    }
    paymentOptions {
      availableMethods
      fullPaymentDueDate
      partialPaymentAmount
      totalAmountDue
    }
    ...OrderMeta
    ...CheckoutDetailsCustomerInfo
  }
}
    ${CheckoutPaymentOrderItemFragmentDoc}
${OrderMetaFragmentDoc}
${CheckoutDetailsCustomerInfoFragmentDoc}`;
const OrderSummaryItemBookingFragmentDoc = exports.OrderSummaryItemBookingFragmentDoc = (0, _client.gql)`
    fragment OrderSummaryItemBooking on Booking {
  rentalUnit {
    id
    code
    name
    slug
    maxOccupancy
    maxExtraBabyOccupancy
    minOccupancy
    petsAllowed
    accommodation {
      id
      hasPublicPage
      name
      checkInEndTime
      checkInStartTime
      checkOutTime
      type
    }
    type
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
  }
}
    ${TransformFragmentDoc}`;
const OrderSummaryItemTicketFragmentDoc = exports.OrderSummaryItemTicketFragmentDoc = (0, _client.gql)`
    fragment OrderSummaryItemTicket on Ticket {
  activity {
    id
    slug
    name
    place
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
  }
  timeslot {
    id
    startDateTime
    endDateTime
    rateGroup {
      rates {
        id
        name
        price
      }
    }
  }
}
    ${TransformFragmentDoc}`;
const PriceLineFragmentDoc = exports.PriceLineFragmentDoc = (0, _client.gql)`
    fragment PriceLine on PriceLine {
  label
  quantity
  totalPrice
  unitPrice
  category
}
    `;
const OrderSummaryItemUpsellPurchaseFragmentDoc = exports.OrderSummaryItemUpsellPurchaseFragmentDoc = (0, _client.gql)`
    fragment OrderSummaryItemUpsellPurchase on UpsellPurchase {
  priceLines {
    ...PriceLine
  }
  totalPrice
  paymentPrice
  offer {
    id
  }
}
    ${PriceLineFragmentDoc}`;
const OrderSummaryItemFragmentDoc = exports.OrderSummaryItemFragmentDoc = (0, _client.gql)`
    fragment OrderSummaryItem on OrderItem {
  ...OrderSummaryItemBooking
  ...OrderSummaryItemTicket
  ...OrderSummaryItemUpsellPurchase
  ...CartOrderItem
}
    ${OrderSummaryItemBookingFragmentDoc}
${OrderSummaryItemTicketFragmentDoc}
${OrderSummaryItemUpsellPurchaseFragmentDoc}
${CartOrderItemFragmentDoc}`;
const OrderSummaryFragmentDoc = exports.OrderSummaryFragmentDoc = (0, _client.gql)`
    fragment OrderSummary on Order {
  orderItems {
    ...OrderSummaryItem
  }
  paymentOptions {
    partialPaymentAmount
  }
  ...OrderMeta
}
    ${OrderSummaryItemFragmentDoc}
${OrderMetaFragmentDoc}`;
const CheckoutPaymentOrderFragmentDoc = exports.CheckoutPaymentOrderFragmentDoc = (0, _client.gql)`
    fragment CheckoutPaymentOrder on Order {
  id
  payments {
    date
    amount
    status
  }
  paymentOptions {
    availableMethods
    fullPaymentDueDate
    partialPaymentAmount
    totalAmountDue
  }
  ...OrderSummary
  ...CheckoutDetailsCustomerInfo
}
    ${OrderSummaryFragmentDoc}
${CheckoutDetailsCustomerInfoFragmentDoc}`;
const CompanyHitFragmentDoc = exports.CompanyHitFragmentDoc = (0, _client.gql)`
    fragment CompanyHit on Company {
  name
  slug
  id
  place
  targetAudiences
  videoUrl
  categories {
    slug
  }
  mainImage {
    transform(config: HERO, format: JPEG) {
      ...ListImage
    }
  }
  webpMainImage: mainImage {
    transform(config: HERO, format: WEBP) {
      ...ListImage
    }
  }
  webpListImage: listImage {
    transform(config: TILE, format: WEBP) {
      ...ListImage
    }
  }
  listImage {
    transform(config: TILE, format: JPEG) {
      ...ListImage
    }
  }
  normalOperatingHours {
    monday {
      timeOpen
      timeClosed
    }
    tuesday {
      timeOpen
      timeClosed
    }
    wednesday {
      timeOpen
      timeClosed
    }
    thursday {
      timeOpen
      timeClosed
    }
    friday {
      timeOpen
      timeClosed
    }
    saturday {
      timeOpen
      timeClosed
    }
    sunday {
      timeOpen
      timeClosed
    }
  }
  specialOperatingHours {
    startDate
    endDate
    monday {
      timeOpen
      timeClosed
    }
    tuesday {
      timeOpen
      timeClosed
    }
    wednesday {
      timeOpen
      timeClosed
    }
    thursday {
      timeOpen
      timeClosed
    }
    friday {
      timeOpen
      timeClosed
    }
    saturday {
      timeOpen
      timeClosed
    }
    sunday {
      timeOpen
      timeClosed
    }
  }
}
    ${ListImageFragmentDoc}`;
const ReviewFragmentDoc = exports.ReviewFragmentDoc = (0, _client.gql)`
    fragment Review on Review {
  id
  average
  comment
  date
  ratingHospitality
  ratingLayout
  ratingLocation
  ratingMaintenance
  ratingValueForMoney
  tips
  title
  travelGroupType
  reply
}
    `;
const ReviewStatsFragmentDoc = exports.ReviewStatsFragmentDoc = (0, _client.gql)`
    fragment ReviewStats on ReviewStats {
  count
  average
  location
  hospitality
  layout
  maintenance
  valueForMoney
}
    `;
const ActivityReviewFragmentDoc = exports.ActivityReviewFragmentDoc = (0, _client.gql)`
    fragment ActivityReview on ActivityReview {
  id
  title
  average
  comment
  date
  ratingHospitality
  ratingActivity
  ratingValueForMoney
  tips
  reply
}
    `;
const ActivityReviewStatsFragmentDoc = exports.ActivityReviewStatsFragmentDoc = (0, _client.gql)`
    fragment ActivityReviewStats on ActivityReviewStats {
  count
  average
  activity
  hospitality
  valueForMoney
}
    `;
const ReviewModalFragmentDoc = exports.ReviewModalFragmentDoc = (0, _client.gql)`
    fragment ReviewModal on OrderItem {
  ... on Booking {
    id
    review {
      ...Review
    }
    rentalUnit {
      id
      flexCancellationDays
      reviewStats {
        ...ReviewStats
      }
      accommodation {
        id
        ownerName
        jpegOwner: ownerImage {
          transform(config: AVATAR, format: JPEG) {
            ...Transform
          }
        }
        webpOwner: ownerImage {
          transform(config: AVATAR, format: WEBP) {
            ...Transform
          }
        }
      }
    }
  }
  ... on Ticket {
    id
    activityReview {
      ...ActivityReview
    }
    activity {
      activityReviewStats {
        ...ActivityReviewStats
      }
    }
  }
  ...OrderSummaryItem
}
    ${ReviewFragmentDoc}
${ReviewStatsFragmentDoc}
${TransformFragmentDoc}
${ActivityReviewFragmentDoc}
${ActivityReviewStatsFragmentDoc}
${OrderSummaryItemFragmentDoc}`;
const OrderBookingFragmentDoc = exports.OrderBookingFragmentDoc = (0, _client.gql)`
    fragment OrderBooking on Booking {
  id
  downloadVoucherUrl
  isCancellable
  isAlterable
  isTravelGroupAlterable
  isSurchargesAlterable
  customerComment
  ...ReviewModal
}
    ${ReviewModalFragmentDoc}`;
const OrderTicketFragmentDoc = exports.OrderTicketFragmentDoc = (0, _client.gql)`
    fragment OrderTicket on Ticket {
  id
  downloadVoucherUrl
  ticketStatus: status
  ...ReviewModal
}
    ${ReviewModalFragmentDoc}`;
const OrderItemFragmentDoc = exports.OrderItemFragmentDoc = (0, _client.gql)`
    fragment OrderItem on OrderItem {
  id
  ...OrderBooking
  ...OrderTicket
  ...OrderSummaryItem
}
    ${OrderBookingFragmentDoc}
${OrderTicketFragmentDoc}
${OrderSummaryItemFragmentDoc}`;
const MyOrderFragmentDoc = exports.MyOrderFragmentDoc = (0, _client.gql)`
    fragment MyOrder on Order {
  id
  number
  createdDate
  paymentOptions {
    fullPaymentDueDate
    totalAmountDue
  }
  orderItems {
    ...OrderItem
  }
  payments {
    status
  }
}
    ${OrderItemFragmentDoc}`;
const MyFavoritesFragmentDoc = exports.MyFavoritesFragmentDoc = (0, _client.gql)`
    fragment MyFavorites on Favorite {
  id
  ... on FavoriteRentalUnit {
    rentalUnit {
      slug
      name
      id
      jpegThumbnail: listImage {
        transform(config: TILE, format: JPEG) {
          ...Transform
        }
      }
      webpThumbnail: listImage {
        transform(config: TILE, format: WEBP) {
          ...Transform
        }
      }
    }
  }
  ... on FavoriteCompany {
    company {
      slug
      name
      id
      jpegThumbnail: listImage {
        transform(config: TILE, format: JPEG) {
          ...Transform
        }
      }
      webpThumbnail: listImage {
        transform(config: TILE, format: WEBP) {
          ...Transform
        }
      }
    }
  }
  ... on FavoriteActivity {
    activity {
      slug
      name
      id
      jpegThumbnail: listImage {
        transform(config: TILE, format: JPEG) {
          ...Transform
        }
      }
      webpThumbnail: listImage {
        transform(config: TILE, format: WEBP) {
          ...Transform
        }
      }
    }
  }
}
    ${TransformFragmentDoc}`;
const MyCustomerFragmentDoc = exports.MyCustomerFragmentDoc = (0, _client.gql)`
    fragment MyCustomer on Customer {
  id
  firstName
  lastName
  birthdate
  email
  address {
    ...Address
  }
  phoneNumber
  orders {
    ...MyOrder
  }
  favorites {
    ...MyFavorites
  }
}
    ${AddressFragmentDoc}
${MyOrderFragmentDoc}
${MyFavoritesFragmentDoc}`;
const OrderDetailsFragmentDoc = exports.OrderDetailsFragmentDoc = (0, _client.gql)`
    fragment OrderDetails on Order {
  id
  number
  createdDate
  downloadOverviewUrl
  payments {
    date
    amount
    status
  }
  paymentOptions {
    fullPaymentDueDate
    partialPaymentAmount
  }
  orderItems {
    ...OrderItem
  }
  ...OrderSummary
}
    ${OrderItemFragmentDoc}
${OrderSummaryFragmentDoc}`;
const PropertyFilterCountsFragmentDoc = exports.PropertyFilterCountsFragmentDoc = (0, _client.gql)`
    fragment PropertyFilterCounts on PropertyFilterCount {
  hits
  property
}
    `;
const BookingFragmentDoc = exports.BookingFragmentDoc = (0, _client.gql)`
    fragment Booking on OrderItem {
  priceLines {
    label
    quantity
    totalPrice
    unitPrice
  }
  totalPrice
  ... on Booking {
    amountAdults
    amountPets
    amountChildren
    amountBabies
    amountYouths
    arrivalDate
    departureDate
    hasCancellationInsurance
    hasContentsInsurance
    optionalSurcharges {
      rentalUnitSurchargeId
      amount
    }
    rentalUnit {
      id
    }
  }
}
    `;
const PlannerTripFragmentDoc = exports.PlannerTripFragmentDoc = (0, _client.gql)`
    fragment PlannerTrip on Trip {
  date
  price
  duration
  type
  originalPrice
  specialId
}
    `;
const GetCartFragmentDoc = exports.GetCartFragmentDoc = (0, _client.gql)`
    fragment GetCart on Cart {
  id
  status
  availableUpsellOffers {
    id
    name
    unitPrice
    maxAmount
    description
  }
  order {
    orderItems {
      ...CartOrderItem
    }
  }
}
    ${CartOrderItemFragmentDoc}`;
const SurchargeFragmentDoc = exports.SurchargeFragmentDoc = (0, _client.gql)`
    fragment Surcharge on RentalUnitSurcharge {
  id
  name
  calculation
  description
  maxAmount
  minAmount
  unitPrice
}
    `;
const ActivityAtlternativesDocument = exports.ActivityAtlternativesDocument = (0, _client.gql)`
    query ActivityAtlternatives($params: ActivitySearchParamsInput!, $limit: Int, $startDate: String!, $endDate: String!) {
  activities(params: $params, limit: $limit) {
    hits {
      ...ActivityHit
    }
  }
}
    ${ActivityHitFragmentDoc}`;

/**
 * __useActivityAtlternativesQuery__
 *
 * To run a query within a React component, call `useActivityAtlternativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityAtlternativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityAtlternativesQuery({
 *   variables: {
 *      params: // value for 'params'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
function useActivityAtlternativesQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivityAtlternativesDocument, options);
}
function useActivityAtlternativesLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivityAtlternativesDocument, options);
}
const ActivityPlannerDocument = exports.ActivityPlannerDocument = (0, _client.gql)`
    query ActivityPlanner($slug: String!, $startDate: String!, $endDate: String!) {
  activity(slug: $slug) {
    id
    externalBookingUrl
    bookingType
    timeslots(startDate: $startDate, endDate: $endDate) {
      ...ActivityPlannerTimeslot
    }
  }
}
    ${ActivityPlannerTimeslotFragmentDoc}`;

/**
 * __useActivityPlannerQuery__
 *
 * To run a query within a React component, call `useActivityPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityPlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityPlannerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
function useActivityPlannerQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivityPlannerDocument, options);
}
function useActivityPlannerLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivityPlannerDocument, options);
}
const SearchSurchargesDocument = exports.SearchSurchargesDocument = (0, _client.gql)`
    query SearchSurcharges($slug: String!, $arrivalDate: String) {
  rentalUnit(slug: $slug) {
    id
    surcharges(arrivalDate: $arrivalDate) {
      ...Surcharge
    }
  }
}
    ${SurchargeFragmentDoc}`;

/**
 * __useSearchSurchargesQuery__
 *
 * To run a query within a React component, call `useSearchSurchargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSurchargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSurchargesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      arrivalDate: // value for 'arrivalDate'
 *   },
 * });
 */
function useSearchSurchargesQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(SearchSurchargesDocument, options);
}
function useSearchSurchargesLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(SearchSurchargesDocument, options);
}
const CheckoutOrderPageDocument = exports.CheckoutOrderPageDocument = (0, _client.gql)`
    query CheckoutOrderPage($orderId: ID!) {
  order(id: $orderId) {
    id
    payments {
      ...Payment
    }
    ...OrderSummary
  }
}
    ${PaymentFragmentDoc}
${OrderSummaryFragmentDoc}`;

/**
 * __useCheckoutOrderPageQuery__
 *
 * To run a query within a React component, call `useCheckoutOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutOrderPageQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
function useCheckoutOrderPageQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutOrderPageDocument, options);
}
function useCheckoutOrderPageLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutOrderPageDocument, options);
}
const CheckoutPageDocument = exports.CheckoutPageDocument = (0, _client.gql)`
    query CheckoutPage($id: ID!) {
  cart(id: $id) {
    id
    status
    order {
      ...OrderSummary
    }
    availableUpsellOffers {
      id
      name
      unitPrice
      maxAmount
      description
    }
  }
}
    ${OrderSummaryFragmentDoc}`;

/**
 * __useCheckoutPageQuery__
 *
 * To run a query within a React component, call `useCheckoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useCheckoutPageQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutPageDocument, options);
}
function useCheckoutPageLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutPageDocument, options);
}
const DeskModeDocument = exports.DeskModeDocument = (0, _client.gql)`
    query DeskMode($id: ID!) {
  cart(id: $id) {
    id
    order {
      isDeskOrder
    }
  }
}
    `;

/**
 * __useDeskModeQuery__
 *
 * To run a query within a React component, call `useDeskModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeskModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeskModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useDeskModeQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(DeskModeDocument, options);
}
function useDeskModeLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(DeskModeDocument, options);
}
const UpdateCustomerDocument = exports.UpdateCustomerDocument = (0, _client.gql)`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    customer {
      id
      ...CustomerDetails
    }
  }
}
    ${CustomerDetailsFragmentDoc}`;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateCustomerMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(UpdateCustomerDocument, options);
}
const FavoriteButtonDocument = exports.FavoriteButtonDocument = (0, _client.gql)`
    query FavoriteButton {
  viewer {
    favorites {
      __typename
      id
      targetId
    }
  }
}
    `;

/**
 * __useFavoriteButtonQuery__
 *
 * To run a query within a React component, call `useFavoriteButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteButtonQuery({
 *   variables: {
 *   },
 * });
 */
function useFavoriteButtonQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(FavoriteButtonDocument, options);
}
function useFavoriteButtonLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(FavoriteButtonDocument, options);
}
const AddFavoriteActivityDocument = exports.AddFavoriteActivityDocument = (0, _client.gql)`
    mutation addFavoriteActivity($input: AddFavoriteActivityInput!) {
  result: addFavoriteActivity(input: $input) {
    favorite {
      ...MyFavorites
    }
  }
}
    ${MyFavoritesFragmentDoc}`;

/**
 * __useAddFavoriteActivityMutation__
 *
 * To run a mutation, you first call `useAddFavoriteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteActivityMutation, { data, loading, error }] = useAddFavoriteActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useAddFavoriteActivityMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(AddFavoriteActivityDocument, options);
}
const AddFavoriteCompanyDocument = exports.AddFavoriteCompanyDocument = (0, _client.gql)`
    mutation addFavoriteCompany($input: AddFavoriteCompanyInput!) {
  result: addFavoriteCompany(input: $input) {
    favorite {
      ...MyFavorites
    }
  }
}
    ${MyFavoritesFragmentDoc}`;

/**
 * __useAddFavoriteCompanyMutation__
 *
 * To run a mutation, you first call `useAddFavoriteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteCompanyMutation, { data, loading, error }] = useAddFavoriteCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useAddFavoriteCompanyMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(AddFavoriteCompanyDocument, options);
}
const AddFavoriteRentalUnitDocument = exports.AddFavoriteRentalUnitDocument = (0, _client.gql)`
    mutation addFavoriteRentalUnit($input: AddFavoriteRentalUnitInput!) {
  result: addFavoriteRentalUnit(input: $input) {
    favorite {
      ...MyFavorites
    }
  }
}
    ${MyFavoritesFragmentDoc}`;

/**
 * __useAddFavoriteRentalUnitMutation__
 *
 * To run a mutation, you first call `useAddFavoriteRentalUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteRentalUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteRentalUnitMutation, { data, loading, error }] = useAddFavoriteRentalUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useAddFavoriteRentalUnitMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(AddFavoriteRentalUnitDocument, options);
}
const RemoveFavoriteDocument = exports.RemoveFavoriteDocument = (0, _client.gql)`
    mutation removeFavorite($input: RemoveFavoriteInput!) {
  removeFavorite(input: $input) {
    success
  }
}
    `;

/**
 * __useRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteMutation, { data, loading, error }] = useRemoveFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useRemoveFavoriteMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(RemoveFavoriteDocument, options);
}
const MeDocument = exports.MeDocument = (0, _client.gql)`
    query Me {
  viewer {
    id
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
function useMeQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(MeDocument, options);
}
function useMeLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(MeDocument, options);
}
const SendAuthenticationEmailDocument = exports.SendAuthenticationEmailDocument = (0, _client.gql)`
    mutation SendAuthenticationEmail($input: SendAuthenticationEmailInput!) {
  sendAuthenticationEmail(input: $input) {
    success
  }
}
    `;

/**
 * __useSendAuthenticationEmailMutation__
 *
 * To run a mutation, you first call `useSendAuthenticationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthenticationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthenticationEmailMutation, { data, loading, error }] = useSendAuthenticationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useSendAuthenticationEmailMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(SendAuthenticationEmailDocument, options);
}
const RegisterDocument = exports.RegisterDocument = (0, _client.gql)`
    mutation Register($input: RegisterInput!) {
  register(input: $input) {
    customer {
      id
    }
  }
}
    `;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useRegisterMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(RegisterDocument, options);
}
const LeaveReviewDocument = exports.LeaveReviewDocument = (0, _client.gql)`
    mutation LeaveReview($input: LeaveReviewInput!) {
  leaveReview(input: $input) {
    review {
      ...Review
    }
  }
}
    ${ReviewFragmentDoc}`;

/**
 * __useLeaveReviewMutation__
 *
 * To run a mutation, you first call `useLeaveReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveReviewMutation, { data, loading, error }] = useLeaveReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useLeaveReviewMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(LeaveReviewDocument, options);
}
const LeaveActivityReviewDocument = exports.LeaveActivityReviewDocument = (0, _client.gql)`
    mutation LeaveActivityReview($input: LeaveActivityReviewInput!) {
  leaveActivityReview(input: $input) {
    activityReview {
      ...ActivityReview
    }
  }
}
    ${ActivityReviewFragmentDoc}`;

/**
 * __useLeaveActivityReviewMutation__
 *
 * To run a mutation, you first call `useLeaveActivityReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveActivityReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveActivityReviewMutation, { data, loading, error }] = useLeaveActivityReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useLeaveActivityReviewMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(LeaveActivityReviewDocument, options);
}
const ReviewsDocument = exports.ReviewsDocument = (0, _client.gql)`
    query Reviews($slug: String!, $limit: Int!, $offset: Int) {
  rentalUnit(slug: $slug) {
    id
    reviews(limit: $limit, offset: $offset) {
      ...UnitReviews
    }
  }
  activity(slug: $slug) {
    id
    activityReviews(limit: $limit, offset: $offset) {
      ...ActivityReviews
    }
  }
}
    ${UnitReviewsFragmentDoc}
${ActivityReviewsFragmentDoc}`;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
function useReviewsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ReviewsDocument, options);
}
function useReviewsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ReviewsDocument, options);
}
const UnitSearchAlternativeDatesDocument = exports.UnitSearchAlternativeDatesDocument = (0, _client.gql)`
    query UnitSearchAlternativeDates($params: UnitAndTripSearchParamsInput!) {
  unitSearchAlternativeDates(params: $params) {
    hits
    date
  }
}
    `;

/**
 * __useUnitSearchAlternativeDatesQuery__
 *
 * To run a query within a React component, call `useUnitSearchAlternativeDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitSearchAlternativeDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitSearchAlternativeDatesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
function useUnitSearchAlternativeDatesQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitSearchAlternativeDatesDocument, options);
}
function useUnitSearchAlternativeDatesLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitSearchAlternativeDatesDocument, options);
}
const SearchRentalUnitsDocument = exports.SearchRentalUnitsDocument = (0, _client.gql)`
    query SearchRentalUnits($slug: String!, $params: UnitSearchParamsInput, $limit: Int, $offset: Int, $badgeHandle: String!, $badge2Handle: String!) {
  accommodation(slug: $slug) {
    id
    searchRentalUnits(params: $params, limit: $limit, offset: $offset) {
      ...SearchRentalUnits
    }
  }
}
    ${SearchRentalUnitsFragmentDoc}`;

/**
 * __useSearchRentalUnitsQuery__
 *
 * To run a query within a React component, call `useSearchRentalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRentalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRentalUnitsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useSearchRentalUnitsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(SearchRentalUnitsDocument, options);
}
function useSearchRentalUnitsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(SearchRentalUnitsDocument, options);
}
const SpecialDocument = exports.SpecialDocument = (0, _client.gql)`
    query Special($id: ID!) {
  special(id: $id) {
    id
    description
    landingPageUrl
    name
  }
}
    `;

/**
 * __useSpecialQuery__
 *
 * To run a query within a React component, call `useSpecialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useSpecialQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(SpecialDocument, options);
}
function useSpecialLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(SpecialDocument, options);
}
const UnitRelevantAlternativesDocument = exports.UnitRelevantAlternativesDocument = (0, _client.gql)`
    query UnitRelevantAlternatives($slug: String!, $params: UnitSearchParamsInput, $badgeHandle: String!, $badge2Handle: String!) {
  rentalUnit(slug: $slug) {
    id
    relevantAlternatives(params: $params) {
      ...UnitRelevantAlternatives
    }
  }
}
    ${UnitRelevantAlternativesFragmentDoc}`;

/**
 * __useUnitRelevantAlternativesQuery__
 *
 * To run a query within a React component, call `useUnitRelevantAlternativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitRelevantAlternativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitRelevantAlternativesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useUnitRelevantAlternativesQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitRelevantAlternativesDocument, options);
}
function useUnitRelevantAlternativesLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitRelevantAlternativesDocument, options);
}
const AccommodationDetailsDocument = exports.AccommodationDetailsDocument = (0, _client.gql)`
    query AccommodationDetails($slug: String!) {
  accommodation(slug: $slug) {
    id
    slug
    jpegHero: mainImage {
      transform(config: HERO, format: JPEG) {
        ...Transform
      }
    }
    webpHero: mainImage {
      transform(config: HERO, format: WEBP) {
        ...Transform
      }
    }
    type
    name
    hasPublicPage
    place
    descriptionGeneral
    descriptionLocation
    images {
      ...Images
    }
    attributeCategories {
      ...Extras
    }
    ...Location
  }
}
    ${TransformFragmentDoc}
${ImagesFragmentDoc}
${ExtrasFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useAccommodationDetailsQuery__
 *
 * To run a query within a React component, call `useAccommodationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useAccommodationDetailsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(AccommodationDetailsDocument, options);
}
function useAccommodationDetailsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(AccommodationDetailsDocument, options);
}
const ActivityDetailDocument = exports.ActivityDetailDocument = (0, _client.gql)`
    query ActivityDetail($slug: String!) {
  activity(slug: $slug) {
    id
    slug
    externalBookingUrl
    externalInfoUrl
    bookingType
    videoUrl
    jpegHero: mainImage {
      transform(config: HERO, format: JPEG) {
        ...Transform
      }
    }
    webpHero: mainImage {
      transform(config: HERO, format: WEBP) {
        ...Transform
      }
    }
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
    place
    name
    minCapacity
    maxCapacity
    targetAudiences
    themes {
      id
      name
    }
    activityReviewStats {
      count
      average
      activity
      hospitality
      valueForMoney
    }
    activityReviews(limit: 3, offset: 0) {
      ...ActivityReviews
    }
    description
    coordinates {
      lat
      lon
    }
    descriptionLocation
    descriptionParticulars
    images {
      jpegTile: transform(config: TILE, format: JPEG) {
        ...Transform
      }
      webpTile: transform(config: TILE, format: WEBP) {
        ...Transform
      }
      jpegGallery: transform(config: GALLERY, format: JPEG) {
        ...Transform
      }
      webpGallery: transform(config: GALLERY, format: WEBP) {
        ...Transform
      }
    }
    company {
      id
      name
      description
      slug
      webpMain: mainImage {
        transform(config: HERO, format: WEBP) {
          ...Transform
        }
      }
      jpegMain: mainImage {
        transform(config: HERO, format: JPEG) {
          ...Transform
        }
      }
      ...CompanyOperatingHours
    }
  }
}
    ${TransformFragmentDoc}
${ActivityReviewsFragmentDoc}
${CompanyOperatingHoursFragmentDoc}`;

/**
 * __useActivityDetailQuery__
 *
 * To run a query within a React component, call `useActivityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useActivityDetailQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivityDetailDocument, options);
}
function useActivityDetailLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivityDetailDocument, options);
}
const ActivityIframePlannerDocument = exports.ActivityIframePlannerDocument = (0, _client.gql)`
    query ActivityIframePlanner($slug: String!) {
  activity(slug: $slug) {
    id
    bookingType
    externalBookingUrl
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
    name
    descriptionParticulars
  }
}
    ${TransformFragmentDoc}`;

/**
 * __useActivityIframePlannerQuery__
 *
 * To run a query within a React component, call `useActivityIframePlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityIframePlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityIframePlannerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useActivityIframePlannerQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivityIframePlannerDocument, options);
}
function useActivityIframePlannerLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivityIframePlannerDocument, options);
}
const ActivityReviewDocument = exports.ActivityReviewDocument = (0, _client.gql)`
    query ActivityReview($activitySlug: String!) {
  activity(slug: $activitySlug) {
    ...LeaveActivityReviews
  }
}
    ${LeaveActivityReviewsFragmentDoc}`;

/**
 * __useActivityReviewQuery__
 *
 * To run a query within a React component, call `useActivityReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReviewQuery({
 *   variables: {
 *      activitySlug: // value for 'activitySlug'
 *   },
 * });
 */
function useActivityReviewQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivityReviewDocument, options);
}
function useActivityReviewLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivityReviewDocument, options);
}
const LeaveUnauthenticatedActivityReviewDocument = exports.LeaveUnauthenticatedActivityReviewDocument = (0, _client.gql)`
    mutation LeaveUnauthenticatedActivityReview($input: LeaveUnauthenticatedActivityReviewInput!) {
  leaveUnauthenticatedActivityReview(input: $input) {
    activityReview {
      ...ActivityReview
    }
  }
}
    ${ActivityReviewFragmentDoc}`;

/**
 * __useLeaveUnauthenticatedActivityReviewMutation__
 *
 * To run a mutation, you first call `useLeaveUnauthenticatedActivityReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveUnauthenticatedActivityReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveUnauthenticatedActivityReviewMutation, { data, loading, error }] = useLeaveUnauthenticatedActivityReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useLeaveUnauthenticatedActivityReviewMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(LeaveUnauthenticatedActivityReviewDocument, options);
}
const ActivitySearchDocument = exports.ActivitySearchDocument = (0, _client.gql)`
    query ActivitySearch($params: ActivitySearchParamsInput!, $limit: Int, $offset: Int, $order: ActivitySearchOrderEnum!, $startDate: String!, $endDate: String!) {
  activities(params: $params, limit: $limit, offset: $offset, order: $order) {
    ... on ActivitySearchResult {
      totalHits
      hits {
        ...ActivityHit
      }
      placeCounts {
        value
        hits
      }
      themeCounts {
        value
        hits
      }
      targetAudienceCount {
        value
        hits
      }
    }
  }
}
    ${ActivityHitFragmentDoc}`;

/**
 * __useActivitySearchQuery__
 *
 * To run a query within a React component, call `useActivitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySearchQuery({
 *   variables: {
 *      params: // value for 'params'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
function useActivitySearchQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(ActivitySearchDocument, options);
}
function useActivitySearchLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(ActivitySearchDocument, options);
}
const AgendaFiltersDocument = exports.AgendaFiltersDocument = (0, _client.gql)`
    query AgendaFilters {
  activityThemes {
    slug
    name
    position
  }
  places {
    id
    position
    name
  }
}
    `;

/**
 * __useAgendaFiltersQuery__
 *
 * To run a query within a React component, call `useAgendaFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaFiltersQuery({
 *   variables: {
 *   },
 * });
 */
function useAgendaFiltersQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(AgendaFiltersDocument, options);
}
function useAgendaFiltersLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(AgendaFiltersDocument, options);
}
const BookingAlterationPreviewDocument = exports.BookingAlterationPreviewDocument = (0, _client.gql)`
    query BookingAlterationPreview($input: AlterBookingInput!) {
  bookingAlterationPreview(input: $input) {
    bookingPreview {
      ...OrderBooking
    }
    newOrderAmountDue
  }
}
    ${OrderBookingFragmentDoc}`;

/**
 * __useBookingAlterationPreviewQuery__
 *
 * To run a query within a React component, call `useBookingAlterationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAlterationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAlterationPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useBookingAlterationPreviewQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(BookingAlterationPreviewDocument, options);
}
function useBookingAlterationPreviewLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(BookingAlterationPreviewDocument, options);
}
const AlterBookingDocument = exports.AlterBookingDocument = (0, _client.gql)`
    mutation AlterBooking($input: AlterBookingInput!) {
  alterBooking(input: $input) {
    booking {
      ...OrderBooking
    }
  }
}
    ${OrderBookingFragmentDoc}`;

/**
 * __useAlterBookingMutation__
 *
 * To run a mutation, you first call `useAlterBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlterBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alterBookingMutation, { data, loading, error }] = useAlterBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useAlterBookingMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(AlterBookingDocument, options);
}
const RentalUnitReviewDocument = exports.RentalUnitReviewDocument = (0, _client.gql)`
    query RentalUnitReview($unitSlug: String!) {
  rentalUnit(slug: $unitSlug) {
    ...RentalUnitReview
  }
}
    ${RentalUnitReviewFragmentDoc}`;

/**
 * __useRentalUnitReviewQuery__
 *
 * To run a query within a React component, call `useRentalUnitReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalUnitReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalUnitReviewQuery({
 *   variables: {
 *      unitSlug: // value for 'unitSlug'
 *   },
 * });
 */
function useRentalUnitReviewQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(RentalUnitReviewDocument, options);
}
function useRentalUnitReviewLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(RentalUnitReviewDocument, options);
}
const LeaveUnauthenticatedReviewDocument = exports.LeaveUnauthenticatedReviewDocument = (0, _client.gql)`
    mutation LeaveUnauthenticatedReview($input: LeaveUnauthenticatedReviewInput!) {
  leaveUnauthenticatedReview(input: $input) {
    review {
      ...Review
    }
  }
}
    ${ReviewFragmentDoc}`;

/**
 * __useLeaveUnauthenticatedReviewMutation__
 *
 * To run a mutation, you first call `useLeaveUnauthenticatedReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveUnauthenticatedReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveUnauthenticatedReviewMutation, { data, loading, error }] = useLeaveUnauthenticatedReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useLeaveUnauthenticatedReviewMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(LeaveUnauthenticatedReviewDocument, options);
}
const BookingCancellationPreviewDocument = exports.BookingCancellationPreviewDocument = (0, _client.gql)`
    query BookingCancellationPreview($input: CancelBookingInput!) {
  bookingCancellationPreview(input: $input) {
    bookingPreview {
      ...OrderBooking
    }
    newOrderAmountDue
  }
}
    ${OrderBookingFragmentDoc}`;

/**
 * __useBookingCancellationPreviewQuery__
 *
 * To run a query within a React component, call `useBookingCancellationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingCancellationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingCancellationPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useBookingCancellationPreviewQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(BookingCancellationPreviewDocument, options);
}
function useBookingCancellationPreviewLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(BookingCancellationPreviewDocument, options);
}
const CancelBookingDocument = exports.CancelBookingDocument = (0, _client.gql)`
    mutation CancelBooking($input: CancelBookingInput!) {
  cancelBooking(input: $input) {
    booking {
      ...OrderBooking
    }
  }
}
    ${OrderBookingFragmentDoc}`;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCancelBookingMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(CancelBookingDocument, options);
}
const CheckoutConfirmDocument = exports.CheckoutConfirmDocument = (0, _client.gql)`
    query CheckoutConfirm($cartId: ID!) {
  cart(id: $cartId) {
    id
    status
    order {
      customer {
        ...OrderCustomerInfo
      }
      orderItems {
        ...CheckoutConfirmOrderItem
      }
      number
      ...OrderMeta
    }
  }
}
    ${OrderCustomerInfoFragmentDoc}
${CheckoutConfirmOrderItemFragmentDoc}
${OrderMetaFragmentDoc}`;

/**
 * __useCheckoutConfirmQuery__
 *
 * To run a query within a React component, call `useCheckoutConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutConfirmQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useCheckoutConfirmQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutConfirmDocument, options);
}
function useCheckoutConfirmLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutConfirmDocument, options);
}
const CheckoutConfirmOrderDocument = exports.CheckoutConfirmOrderDocument = (0, _client.gql)`
    query CheckoutConfirmOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    customer {
      ...OrderCustomerInfo
    }
    payments {
      ...Payment
    }
    ...OrderSummary
  }
}
    ${OrderCustomerInfoFragmentDoc}
${PaymentFragmentDoc}
${OrderSummaryFragmentDoc}`;

/**
 * __useCheckoutConfirmOrderQuery__
 *
 * To run a query within a React component, call `useCheckoutConfirmOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutConfirmOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutConfirmOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
function useCheckoutConfirmOrderQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutConfirmOrderDocument, options);
}
function useCheckoutConfirmOrderLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutConfirmOrderDocument, options);
}
const CheckoutDetailsDocument = exports.CheckoutDetailsDocument = (0, _client.gql)`
    query CheckoutDetails($cartId: ID!) {
  cart(id: $cartId) {
    ...CheckoutDetails
  }
}
    ${CheckoutDetailsFragmentDoc}`;

/**
 * __useCheckoutDetailsQuery__
 *
 * To run a query within a React component, call `useCheckoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutDetailsQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useCheckoutDetailsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutDetailsDocument, options);
}
function useCheckoutDetailsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutDetailsDocument, options);
}
const CheckoutDetailsMeDocument = exports.CheckoutDetailsMeDocument = (0, _client.gql)`
    query CheckoutDetailsMe {
  viewer {
    id
    ...CustomerDetails
  }
}
    ${CustomerDetailsFragmentDoc}`;

/**
 * __useCheckoutDetailsMeQuery__
 *
 * To run a query within a React component, call `useCheckoutDetailsMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDetailsMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutDetailsMeQuery({
 *   variables: {
 *   },
 * });
 */
function useCheckoutDetailsMeQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutDetailsMeDocument, options);
}
function useCheckoutDetailsMeLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutDetailsMeDocument, options);
}
const UpdateCartFromDetailsDocument = exports.UpdateCartFromDetailsDocument = (0, _client.gql)`
    mutation UpdateCartFromDetails($input: UpdateCartInput!) {
  updateCart(input: $input) {
    checkoutAllowed
    cart {
      ...CheckoutDetails
    }
  }
}
    ${CheckoutDetailsFragmentDoc}`;

/**
 * __useUpdateCartFromDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCartFromDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartFromDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartFromDetailsMutation, { data, loading, error }] = useUpdateCartFromDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateCartFromDetailsMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(UpdateCartFromDetailsDocument, options);
}
const CheckoutExtrasDocument = exports.CheckoutExtrasDocument = (0, _client.gql)`
    query CheckoutExtras($cartId: ID!) {
  cart(id: $cartId) {
    id
    ...CheckoutExtras
  }
}
    ${CheckoutExtrasFragmentDoc}`;

/**
 * __useCheckoutExtrasQuery__
 *
 * To run a query within a React component, call `useCheckoutExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutExtrasQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useCheckoutExtrasQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutExtrasDocument, options);
}
function useCheckoutExtrasLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutExtrasDocument, options);
}
const SetCartExtrasDocument = exports.SetCartExtrasDocument = (0, _client.gql)`
    mutation SetCartExtras($input: UpdateCartInput!) {
  updateCart(input: $input) {
    cart {
      ...CheckoutExtras
    }
  }
}
    ${CheckoutExtrasFragmentDoc}`;

/**
 * __useSetCartExtrasMutation__
 *
 * To run a mutation, you first call `useSetCartExtrasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCartExtrasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCartExtrasMutation, { data, loading, error }] = useSetCartExtrasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useSetCartExtrasMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(SetCartExtrasDocument, options);
}
const UpdateCartDocument = exports.UpdateCartDocument = (0, _client.gql)`
    mutation UpdateCart($input: UpdateCartInput!) {
  updateCart(input: $input) {
    cart {
      ...CheckoutExtras
    }
  }
}
    ${CheckoutExtrasFragmentDoc}`;

/**
 * __useUpdateCartMutation__
 *
 * To run a mutation, you first call `useUpdateCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartMutation, { data, loading, error }] = useUpdateCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateCartMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(UpdateCartDocument, options);
}
const CheckoutPaymentDocument = exports.CheckoutPaymentDocument = (0, _client.gql)`
    query CheckoutPayment($cartId: ID!) {
  cart(id: $cartId) {
    ...CheckoutPayment
  }
}
    ${CheckoutPaymentFragmentDoc}`;

/**
 * __useCheckoutPaymentQuery__
 *
 * To run a query within a React component, call `useCheckoutPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPaymentQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useCheckoutPaymentQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutPaymentDocument, options);
}
function useCheckoutPaymentLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutPaymentDocument, options);
}
const CheckoutCartDocument = exports.CheckoutCartDocument = (0, _client.gql)`
    mutation CheckoutCart($input: CheckoutCartInput!) {
  checkoutCart(input: $input) {
    success
    redirectUrl
    cart {
      ...CheckoutPayment
    }
    redirectUrl
  }
}
    ${CheckoutPaymentFragmentDoc}`;

/**
 * __useCheckoutCartMutation__
 *
 * To run a mutation, you first call `useCheckoutCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCartMutation, { data, loading, error }] = useCheckoutCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCheckoutCartMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(CheckoutCartDocument, options);
}
const CheckoutPaymentOrderDocument = exports.CheckoutPaymentOrderDocument = (0, _client.gql)`
    query CheckoutPaymentOrder($orderId: ID!) {
  order(id: $orderId) {
    ...CheckoutPaymentOrder
  }
}
    ${CheckoutPaymentOrderFragmentDoc}`;

/**
 * __useCheckoutPaymentOrderQuery__
 *
 * To run a query within a React component, call `useCheckoutPaymentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPaymentOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
function useCheckoutPaymentOrderQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutPaymentOrderDocument, options);
}
function useCheckoutPaymentOrderLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutPaymentOrderDocument, options);
}
const PayOrderDocument = exports.PayOrderDocument = (0, _client.gql)`
    mutation PayOrder($input: PayOrderInput!) {
  payOrder(input: $input) {
    order {
      ...CheckoutPaymentOrder
    }
    redirectUrl
  }
}
    ${CheckoutPaymentOrderFragmentDoc}`;

/**
 * __usePayOrderMutation__
 *
 * To run a mutation, you first call `usePayOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOrderMutation, { data, loading, error }] = usePayOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function usePayOrderMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(PayOrderDocument, options);
}
const CheckoutRedirectRentalUnitDocument = exports.CheckoutRedirectRentalUnitDocument = (0, _client.gql)`
    query CheckoutRedirectRentalUnit($slug: String!) {
  rentalUnit(slug: $slug) {
    id
    brand
    cancellationInsuranceAvailable
  }
}
    `;

/**
 * __useCheckoutRedirectRentalUnitQuery__
 *
 * To run a query within a React component, call `useCheckoutRedirectRentalUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutRedirectRentalUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutRedirectRentalUnitQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useCheckoutRedirectRentalUnitQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CheckoutRedirectRentalUnitDocument, options);
}
function useCheckoutRedirectRentalUnitLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CheckoutRedirectRentalUnitDocument, options);
}
const CompanySearchDocument = exports.CompanySearchDocument = (0, _client.gql)`
    query CompanySearch($params: CompanySearchParamsInput!, $limit: Int, $offset: Int, $sortByDistanceTo: LatLonInput) {
  companies(
    params: $params
    limit: $limit
    offset: $offset
    sortByDistanceTo: $sortByDistanceTo
  ) {
    ... on CompanySearchResult {
      totalHits
      hits {
        ...CompanyHit
      }
      placeCounts {
        value
        hits
      }
      themeCounts {
        value
        hits
      }
      categoryCounts {
        value
        hits
      }
      mainCategoryCounts {
        value
        hits
      }
      targetAudienceCount {
        value
        hits
      }
    }
  }
}
    ${CompanyHitFragmentDoc}`;

/**
 * __useCompanySearchQuery__
 *
 * To run a query within a React component, call `useCompanySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySearchQuery({
 *   variables: {
 *      params: // value for 'params'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortByDistanceTo: // value for 'sortByDistanceTo'
 *   },
 * });
 */
function useCompanySearchQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CompanySearchDocument, options);
}
function useCompanySearchLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CompanySearchDocument, options);
}
const CompanyFiltersDocument = exports.CompanyFiltersDocument = (0, _client.gql)`
    query CompanyFilters {
  companyCategories {
    name
    slug
    position
    children {
      name
      slug
      position
    }
  }
  places {
    id
    name
  }
}
    `;

/**
 * __useCompanyFiltersQuery__
 *
 * To run a query within a React component, call `useCompanyFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFiltersQuery({
 *   variables: {
 *   },
 * });
 */
function useCompanyFiltersQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CompanyFiltersDocument, options);
}
function useCompanyFiltersLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CompanyFiltersDocument, options);
}
const CompanyDetailDocument = exports.CompanyDetailDocument = (0, _client.gql)`
    query CompanyDetail($slug: String!, $startDate: String!, $endDate: String!) {
  company(slug: $slug) {
    id
    videoUrl
    jpegHero: mainImage {
      transform(config: HERO, format: JPEG) {
        ...Transform
      }
    }
    webpHero: mainImage {
      transform(config: HERO, format: WEBP) {
        ...Transform
      }
    }
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
    place
    name
    description
    categories {
      id
      isRoot
      name
      position
      slug
    }
    socialsFacebookUrl
    socialsInstagramUrl
    socialsTwitterUrl
    email
    phoneNumber
    websiteUrl
    address {
      ...Address
    }
    pngLogo: logoImage {
      transform(config: LOGO, format: PNG) {
        ...Transform
      }
    }
    webpLogo: logoImage {
      transform(config: LOGO, format: WEBP) {
        ...Transform
      }
    }
    coordinates {
      lat
      lon
    }
    ...CompanyOperatingHours
    descriptionParticulars
    images {
      jpegTile: transform(config: TILE, format: JPEG) {
        ...Transform
      }
      webpTile: transform(config: TILE, format: WEBP) {
        ...Transform
      }
      jpegGallery: transform(config: GALLERY, format: JPEG) {
        ...Transform
      }
      webpGallery: transform(config: GALLERY, format: WEBP) {
        ...Transform
      }
    }
    activities {
      ...ActivityHit
    }
  }
}
    ${TransformFragmentDoc}
${AddressFragmentDoc}
${CompanyOperatingHoursFragmentDoc}
${ActivityHitFragmentDoc}`;

/**
 * __useCompanyDetailQuery__
 *
 * To run a query within a React component, call `useCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
function useCompanyDetailQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CompanyDetailDocument, options);
}
function useCompanyDetailLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CompanyDetailDocument, options);
}
const MyDocument = exports.MyDocument = (0, _client.gql)`
    query My {
  viewer {
    ...MyCustomer
  }
}
    ${MyCustomerFragmentDoc}`;

/**
 * __useMyQuery__
 *
 * To run a query within a React component, call `useMyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyQuery({
 *   variables: {
 *   },
 * });
 */
function useMyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(MyDocument, options);
}
function useMyLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(MyDocument, options);
}
const OrderDetailsDocument = exports.OrderDetailsDocument = (0, _client.gql)`
    query OrderDetails($id: ID!) {
  order(id: $id) {
    ...OrderDetails
  }
}
    ${OrderDetailsFragmentDoc}`;

/**
 * __useOrderDetailsQuery__
 *
 * To run a query within a React component, call `useOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useOrderDetailsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(OrderDetailsDocument, options);
}
function useOrderDetailsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(OrderDetailsDocument, options);
}
const PlannerPageRentalUnitDocument = exports.PlannerPageRentalUnitDocument = (0, _client.gql)`
    query PlannerPageRentalUnit($slug: String!) {
  rentalUnit(slug: $slug) {
    id
    brand
    maxOccupancy
    petsAllowed
  }
}
    `;

/**
 * __usePlannerPageRentalUnitQuery__
 *
 * To run a query within a React component, call `usePlannerPageRentalUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannerPageRentalUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannerPageRentalUnitQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function usePlannerPageRentalUnitQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(PlannerPageRentalUnitDocument, options);
}
function usePlannerPageRentalUnitLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(PlannerPageRentalUnitDocument, options);
}
const SearchPageRentalUnitsDocument = exports.SearchPageRentalUnitsDocument = (0, _client.gql)`
    query SearchPageRentalUnits($babies: Int!, $filters: [PropertyFilterInput!], $persons: Int!, $pets: Int!, $mapArea: BoundingBoxInput, $offset: Int, $order: SearchRentalUnitsOrderEnum, $limit: Int, $badgeHandle: String!, $badge2Handle: String!) {
  searchRentalUnits(
    babies: $babies
    filters: $filters
    persons: $persons
    pets: $pets
    mapArea: $mapArea
    limit: $limit
    offset: $offset
    order: $order
  ) {
    hits {
      ...SearchHitRentalUnit
    }
    propertyFilterCounts {
      ...PropertyFilterCounts
    }
    totalHits
  }
}
    ${SearchHitRentalUnitFragmentDoc}
${PropertyFilterCountsFragmentDoc}`;

/**
 * __useSearchPageRentalUnitsQuery__
 *
 * To run a query within a React component, call `useSearchPageRentalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageRentalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageRentalUnitsQuery({
 *   variables: {
 *      babies: // value for 'babies'
 *      filters: // value for 'filters'
 *      persons: // value for 'persons'
 *      pets: // value for 'pets'
 *      mapArea: // value for 'mapArea'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useSearchPageRentalUnitsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(SearchPageRentalUnitsDocument, options);
}
function useSearchPageRentalUnitsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(SearchPageRentalUnitsDocument, options);
}
const SearchTripsDocument = exports.SearchTripsDocument = (0, _client.gql)`
    query SearchTrips($babies: Int!, $date: [String!]!, $duration: [Int!]!, $filters: [PropertyFilterInput!], $persons: Int!, $pets: Int!, $price: RangeFilterInput, $specialId: [ID!], $tripType: [TripTypeEnum!], $mapArea: BoundingBoxInput, $limit: Int, $offset: Int, $order: UnitSearchOrderEnum, $badgeHandle: String!, $badge2Handle: String!) {
  searchTrips(
    babies: $babies
    date: $date
    duration: $duration
    filters: $filters
    persons: $persons
    pets: $pets
    price: $price
    specialId: $specialId
    tripType: $tripType
    mapArea: $mapArea
  ) {
    hits(limit: $limit, offset: $offset, order: $order) {
      ...SearchHitTrip
      rentalUnit {
        ...SearchHitRentalUnit
      }
    }
    stats {
      totalHits
      propertyFilterCounts {
        ...PropertyFilterCounts
      }
      minPrice
      maxPrice
      tripTypeCounts {
        tripType
        hits
      }
      specialCounts {
        special {
          description
          id
          landingPageUrl
          name
        }
        hits
      }
    }
  }
}
    ${SearchHitTripFragmentDoc}
${SearchHitRentalUnitFragmentDoc}
${PropertyFilterCountsFragmentDoc}`;

/**
 * __useSearchTripsQuery__
 *
 * To run a query within a React component, call `useSearchTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTripsQuery({
 *   variables: {
 *      babies: // value for 'babies'
 *      date: // value for 'date'
 *      duration: // value for 'duration'
 *      filters: // value for 'filters'
 *      persons: // value for 'persons'
 *      pets: // value for 'pets'
 *      price: // value for 'price'
 *      specialId: // value for 'specialId'
 *      tripType: // value for 'tripType'
 *      mapArea: // value for 'mapArea'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useSearchTripsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(SearchTripsDocument, options);
}
function useSearchTripsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(SearchTripsDocument, options);
}
const UnitFilterPropertiesDocument = exports.UnitFilterPropertiesDocument = (0, _client.gql)`
    query UnitFilterProperties {
  unitFilterProperties {
    name
    handle
    filterProperties {
      name
      handle
    }
  }
}
    `;

/**
 * __useUnitFilterPropertiesQuery__
 *
 * To run a query within a React component, call `useUnitFilterPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitFilterPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitFilterPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
function useUnitFilterPropertiesQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitFilterPropertiesDocument, options);
}
function useUnitFilterPropertiesLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitFilterPropertiesDocument, options);
}
const UnitSearchPriceFilterDocument = exports.UnitSearchPriceFilterDocument = (0, _client.gql)`
    query UnitSearchPriceFilter($params: UnitSearchParamsInput!) {
  unitSearch(params: $params) {
    minPrice
    maxPrice
  }
}
    `;

/**
 * __useUnitSearchPriceFilterQuery__
 *
 * To run a query within a React component, call `useUnitSearchPriceFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitSearchPriceFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitSearchPriceFilterQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
function useUnitSearchPriceFilterQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitSearchPriceFilterDocument, options);
}
function useUnitSearchPriceFilterLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitSearchPriceFilterDocument, options);
}
const TripPlannerDocument = exports.TripPlannerDocument = (0, _client.gql)`
    query TripPlanner($slug: String!, $start: String!, $end: String!, $persons: Int!, $pets: Int!, $babies: Int!) {
  rentalUnit(slug: $slug) {
    id
    name
    code
    brand
    trips(
      pets: $pets
      persons: $persons
      babies: $babies
      startDate: $start
      endDate: $end
    ) {
      ...PlannerTrip
    }
  }
}
    ${PlannerTripFragmentDoc}`;

/**
 * __useTripPlannerQuery__
 *
 * To run a query within a React component, call `useTripPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripPlannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripPlannerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      persons: // value for 'persons'
 *      pets: // value for 'pets'
 *      babies: // value for 'babies'
 *   },
 * });
 */
function useTripPlannerQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(TripPlannerDocument, options);
}
function useTripPlannerLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(TripPlannerDocument, options);
}
const GetCartDocument = exports.GetCartDocument = (0, _client.gql)`
    query GetCart($id: ID!) {
  cart(id: $id) {
    ...GetCart
  }
}
    ${GetCartFragmentDoc}`;

/**
 * __useGetCartQuery__
 *
 * To run a query within a React component, call `useGetCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetCartQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(GetCartDocument, options);
}
function useGetCartLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(GetCartDocument, options);
}
const CartStatusDocument = exports.CartStatusDocument = (0, _client.gql)`
    query CartStatus($cartId: ID!) {
  cart(id: $cartId) {
    id
    status
  }
}
    `;

/**
 * __useCartStatusQuery__
 *
 * To run a query within a React component, call `useCartStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartStatusQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
function useCartStatusQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(CartStatusDocument, options);
}
function useCartStatusLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(CartStatusDocument, options);
}
const SetCartDocument = exports.SetCartDocument = (0, _client.gql)`
    mutation SetCart($input: UpdateCartInput!) {
  updateCart(input: $input) {
    cart {
      ...GetCart
    }
  }
}
    ${GetCartFragmentDoc}`;

/**
 * __useSetCartMutation__
 *
 * To run a mutation, you first call `useSetCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCartMutation, { data, loading, error }] = useSetCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useSetCartMutation(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useMutation(SetCartDocument, options);
}
const UnitDetailsDocument = exports.UnitDetailsDocument = (0, _client.gql)`
    query UnitDetails($slug: String!, $arrivalDate: String, $bakedInFilterProperty: String!) {
  rentalUnit(slug: $slug) {
    id
    firstTripDate
    flexCancellationDays
    slug
    name
    brand
    jpegThumbnail: listImage {
      transform(config: TILE, format: JPEG) {
        ...Transform
      }
    }
    webpThumbnail: listImage {
      transform(config: TILE, format: WEBP) {
        ...Transform
      }
    }
    jpegHero: mainImage {
      transform(config: HERO, format: JPEG) {
        ...Transform
      }
    }
    webpHero: mainImage {
      transform(config: HERO, format: WEBP) {
        ...Transform
      }
    }
    municipalRegistration
    tagline
    minOccupancy
    maxOccupancy
    maxExtraBabyOccupancy
    petsAllowed
    descriptionLayout
    descriptionParticulars
    descriptionExtras
    cancellationInsuranceAvailable
    fullCircleImageUrl
    videoUrl
    hasBakedInFilterProperty: hasFilterProperty(handle: $bakedInFilterProperty)
    surcharges(arrivalDate: $arrivalDate) {
      ...Surcharge
    }
    reviewStats {
      ...ReviewStats
    }
    ...UnitFeatures
    ...UnitPhotos
    attributeCategories {
      ...Extras
    }
    accommodation {
      id
      slug
      ...UnitAccommodation
      descriptionGeneral
      ...UnitOwner
      ...Location
      ...AccommodationPhotos
      place
      name
      checkInEndTime
      checkInStartTime
      checkOutTime
      hasPublicPage
    }
    reviews(limit: 3, offset: 0) {
      ...UnitReviews
    }
  }
}
    ${TransformFragmentDoc}
${SurchargeFragmentDoc}
${ReviewStatsFragmentDoc}
${UnitFeaturesFragmentDoc}
${UnitPhotosFragmentDoc}
${ExtrasFragmentDoc}
${UnitAccommodationFragmentDoc}
${UnitOwnerFragmentDoc}
${LocationFragmentDoc}
${AccommodationPhotosFragmentDoc}
${UnitReviewsFragmentDoc}`;

/**
 * __useUnitDetailsQuery__
 *
 * To run a query within a React component, call `useUnitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      arrivalDate: // value for 'arrivalDate'
 *      bakedInFilterProperty: // value for 'bakedInFilterProperty'
 *   },
 * });
 */
function useUnitDetailsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitDetailsDocument, options);
}
function useUnitDetailsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitDetailsDocument, options);
}
const UnitDetailsSearchDocument = exports.UnitDetailsSearchDocument = (0, _client.gql)`
    query UnitDetailsSearch($slug: String!, $params: UnitSearchParamsInput, $arrivalDate: String, $badgeHandle: String!, $badge2Handle: String!) {
  rentalUnit(slug: $slug) {
    id
    alternativesInAccommodation(params: $params) {
      hits {
        ...SearchHit
      }
    }
    surcharges(arrivalDate: $arrivalDate) {
      ...Surcharge
    }
  }
}
    ${SearchHitFragmentDoc}
${SurchargeFragmentDoc}`;

/**
 * __useUnitDetailsSearchQuery__
 *
 * To run a query within a React component, call `useUnitDetailsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailsSearchQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *      arrivalDate: // value for 'arrivalDate'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useUnitDetailsSearchQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitDetailsSearchDocument, options);
}
function useUnitDetailsSearchLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitDetailsSearchDocument, options);
}
const UnitDetailInitialTripsDocument = exports.UnitDetailInitialTripsDocument = (0, _client.gql)`
    query UnitDetailInitialTrips($slug: String!, $start: String!, $end: String!, $persons: Int!, $pets: Int!, $babies: Int!) {
  rentalUnit(slug: $slug) {
    id
    trips(
      pets: $pets
      persons: $persons
      babies: $babies
      startDate: $start
      endDate: $end
    ) {
      ...PlannerTrip
    }
  }
}
    ${PlannerTripFragmentDoc}`;

/**
 * __useUnitDetailInitialTripsQuery__
 *
 * To run a query within a React component, call `useUnitDetailInitialTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailInitialTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailInitialTripsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      persons: // value for 'persons'
 *      pets: // value for 'pets'
 *      babies: // value for 'babies'
 *   },
 * });
 */
function useUnitDetailInitialTripsQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(UnitDetailInitialTripsDocument, options);
}
function useUnitDetailInitialTripsLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(UnitDetailInitialTripsDocument, options);
}
const AlternativesInAccommodationDocument = exports.AlternativesInAccommodationDocument = (0, _client.gql)`
    query AlternativesInAccommodation($slug: String!, $params: UnitSearchParamsInput, $badgeHandle: String!, $badge2Handle: String!) {
  rentalUnit(slug: $slug) {
    id
    alternativesInAccommodation(params: $params) {
      hits {
        ...SearchHit
      }
    }
  }
}
    ${SearchHitFragmentDoc}`;

/**
 * __useAlternativesInAccommodationQuery__
 *
 * To run a query within a React component, call `useAlternativesInAccommodationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlternativesInAccommodationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlternativesInAccommodationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      params: // value for 'params'
 *      badgeHandle: // value for 'badgeHandle'
 *      badge2Handle: // value for 'badge2Handle'
 *   },
 * });
 */
function useAlternativesInAccommodationQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(AlternativesInAccommodationDocument, options);
}
function useAlternativesInAccommodationLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(AlternativesInAccommodationDocument, options);
}
const PlannerPageRentalUnitByIdDocument = exports.PlannerPageRentalUnitByIdDocument = (0, _client.gql)`
    query PlannerPageRentalUnitById($id: ID!) {
  rentalUnit: rentalUnitById(id: $id) {
    id
    brand
    maxOccupancy
    petsAllowed
    slug
  }
}
    `;

/**
 * __usePlannerPageRentalUnitByIdQuery__
 *
 * To run a query within a React component, call `usePlannerPageRentalUnitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlannerPageRentalUnitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlannerPageRentalUnitByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function usePlannerPageRentalUnitByIdQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(PlannerPageRentalUnitByIdDocument, options);
}
function usePlannerPageRentalUnitByIdLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(PlannerPageRentalUnitByIdDocument, options);
}
const TorSitemapDocument = exports.TorSitemapDocument = (0, _client.gql)`
    query TorSitemap($params: UnitSearchParamsInput!) {
  unitSearch(params: $params, limit: 9999999) {
    hits {
      rentalUnit {
        accommodation {
          hasPublicPage
          slug
          mainImage {
            transform(format: JPEG, config: HERO) {
              src
            }
          }
        }
        listImage {
          transform(format: JPEG, config: TILE) {
            src
          }
        }
        slug
      }
    }
  }
}
    `;

/**
 * __useTorSitemapQuery__
 *
 * To run a query within a React component, call `useTorSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useTorSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTorSitemapQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
function useTorSitemapQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useQuery(TorSitemapDocument, options);
}
function useTorSitemapLazyQuery(baseOptions) {
  const options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return ApolloReactHooks.useLazyQuery(TorSitemapDocument, options);
}